//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IRoleSelectionClient {
    getRoles( cancelToken?: CancelToken): Promise<RoleDto[]>;
}

export class RoleSelectionClient implements IRoleSelectionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getRoles( cancelToken?: CancelToken): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/selection/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RoleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }
}

export interface IApplicationProfileClient {
    getApplicationProfile( cancelToken?: CancelToken): Promise<ApplicationProfileDto>;
}

export class ApplicationProfileClient implements IApplicationProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getApplicationProfile( cancelToken?: CancelToken): Promise<ApplicationProfileDto> {
        let url_ = this.baseUrl + "/api/application-profile/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationProfile(_response);
        });
    }

    protected processGetApplicationProfile(response: AxiosResponse): Promise<ApplicationProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ApplicationProfileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationProfileDto>(null as any);
    }
}

export interface IRegistrationClient {
    getHistory(moduleRegistrationId: number,  cancelToken?: CancelToken): Promise<RegistrationStateChangeDto[]>;
    getCapacities(semesterId: number,  cancelToken?: CancelToken): Promise<PhaseCapacityDto[]>;
    getPriorities(moduleExecutionId: number,  cancelToken?: CancelToken): Promise<ModuleRegistrationsDto>;
    autoConfirm(semesterId: number, categoryId: number,  cancelToken?: CancelToken): Promise<void>;
    autoConfirmStream(semesterId: number,  cancelToken?: CancelToken): Promise<void>;
    getRegistrationsForUas(uasId: number, semesterId: number,  cancelToken?: CancelToken): Promise<ModuleRegistrationInfoDto[]>;
    changeRegistrationStatesInPrioritization(registrationIds: number[], state?: RegistrationState | undefined, comment?: string | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    deleteRegistrations(semesterId?: number | undefined, uasId?: number | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class RegistrationClient implements IRegistrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getHistory(moduleRegistrationId: number, cancelToken?: CancelToken): Promise<RegistrationStateChangeDto[]> {
        let url_ = this.baseUrl + "/api/registration/history/{moduleRegistrationId}";
        if (moduleRegistrationId === undefined || moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' must be defined.");
        url_ = url_.replace("{moduleRegistrationId}", encodeURIComponent("" + moduleRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: AxiosResponse): Promise<RegistrationStateChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationStateChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationStateChangeDto[]>(null as any);
    }

    getCapacities(semesterId: number, cancelToken?: CancelToken): Promise<PhaseCapacityDto[]> {
        let url_ = this.baseUrl + "/api/registration/capacities/{semesterId}";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCapacities(_response);
        });
    }

    protected processGetCapacities(response: AxiosResponse): Promise<PhaseCapacityDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PhaseCapacityDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhaseCapacityDto[]>(null as any);
    }

    getPriorities(moduleExecutionId: number, cancelToken?: CancelToken): Promise<ModuleRegistrationsDto> {
        let url_ = this.baseUrl + "/api/registration/priority/{moduleExecutionId}";
        if (moduleExecutionId === undefined || moduleExecutionId === null)
            throw new globalThis.Error("The parameter 'moduleExecutionId' must be defined.");
        url_ = url_.replace("{moduleExecutionId}", encodeURIComponent("" + moduleExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriorities(_response);
        });
    }

    protected processGetPriorities(response: AxiosResponse): Promise<ModuleRegistrationsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationsDto>(null as any);
    }

    autoConfirm(semesterId: number, categoryId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration/priority/auto-confirm/{semesterId}/{categoryId}";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutoConfirm(_response);
        });
    }

    protected processAutoConfirm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    autoConfirmStream(semesterId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration/priority/auto-confirm-stream/{semesterId}";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutoConfirmStream(_response);
        });
    }

    protected processAutoConfirmStream(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRegistrationsForUas(uasId: number, semesterId: number, cancelToken?: CancelToken): Promise<ModuleRegistrationInfoDto[]> {
        let url_ = this.baseUrl + "/api/registration/uas/{uasId}/{semesterId}";
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationsForUas(_response);
        });
    }

    protected processGetRegistrationsForUas(response: AxiosResponse): Promise<ModuleRegistrationInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationInfoDto[]>(null as any);
    }

    changeRegistrationStatesInPrioritization(registrationIds: number[], state?: RegistrationState | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/change-state?";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeRegistrationStatesInPrioritization(_response);
        });
    }

    protected processChangeRegistrationStatesInPrioritization(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteRegistrations(semesterId?: number | undefined, uasId?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration?";
        if (semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' cannot be null.");
        else if (semesterId !== undefined)
            url_ += "semesterId=" + encodeURIComponent("" + semesterId) + "&";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRegistrations(_response);
        });
    }

    protected processDeleteRegistrations(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ISummarySheetClient {
    getSummarySheet(summaryFilter: SummaryFilterDto,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class SummarySheetClient implements ISummarySheetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getSummarySheet(summaryFilter: SummaryFilterDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/summary-sheet/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(summaryFilter);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummarySheet(_response);
        });
    }

    protected processGetSummarySheet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IAccountClient {
    activate(accountRequestId: number, roles: RoleType[],  cancelToken?: CancelToken): Promise<boolean>;
    getExistingUser(accountRequestId: number,  cancelToken?: CancelToken): Promise<AccountDto>;
    blockRequest(accountRequestId: number,  cancelToken?: CancelToken): Promise<void>;
    deleteRequest(accountRequestId: number,  cancelToken?: CancelToken): Promise<void>;
    unblockRequest(accountRequestId: number,  cancelToken?: CancelToken): Promise<void>;
    getRequests( cancelToken?: CancelToken): Promise<AccountRequestDto[]>;
    getBlockedRequests( cancelToken?: CancelToken): Promise<AccountRequestDto[]>;
    getCurrentUserInfo( cancelToken?: CancelToken): Promise<UserDto>;
    getAccounts(getInactive?: boolean | undefined,  cancelToken?: CancelToken): Promise<AccountDto[]>;
    register( cancelToken?: CancelToken): Promise<boolean>;
    getAccountInfo(accountId: string,  cancelToken?: CancelToken): Promise<AccountInfoDto>;
    getRoleInfos(accountId: string,  cancelToken?: CancelToken): Promise<RoleInfoDto>;
    checkEmail(userId?: string | null | undefined, email?: string | null | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    update(accountDto: AccountInfoDto,  cancelToken?: CancelToken): Promise<void>;
    delete(accountId: string,  cancelToken?: CancelToken): Promise<void>;
    addRole(accountId: string, roleType: RoleType,  cancelToken?: CancelToken): Promise<void>;
    deleteRole(accountId: string, roleType: RoleType,  cancelToken?: CancelToken): Promise<void>;
    activateRole(roleId: string,  cancelToken?: CancelToken): Promise<void>;
    deactivateRole(roleId: string,  cancelToken?: CancelToken): Promise<void>;
    addUas(roleId: string, uasId: number,  cancelToken?: CancelToken): Promise<void>;
    removeUas(roleId: string, uasId: number,  cancelToken?: CancelToken): Promise<void>;
    addLecturerFor(roleId: string, executionId: number,  cancelToken?: CancelToken): Promise<void>;
    removeLecturerFor(roleId: string, executionId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class AccountClient implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    activate(accountRequestId: number, roles: RoleType[], cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/accounts/activate/{accountRequestId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new globalThis.Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getExistingUser(accountRequestId: number, cancelToken?: CancelToken): Promise<AccountDto> {
        let url_ = this.baseUrl + "/api/accounts/request/existing/{accountRequestId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new globalThis.Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExistingUser(_response);
        });
    }

    protected processGetExistingUser(response: AxiosResponse): Promise<AccountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AccountDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto>(null as any);
    }

    blockRequest(accountRequestId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/request/block/{accountRequestId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new globalThis.Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBlockRequest(_response);
        });
    }

    protected processBlockRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteRequest(accountRequestId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/request/{accountRequestId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new globalThis.Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRequest(_response);
        });
    }

    protected processDeleteRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unblockRequest(accountRequestId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/request/unblock/{accountRequestId}";
        if (accountRequestId === undefined || accountRequestId === null)
            throw new globalThis.Error("The parameter 'accountRequestId' must be defined.");
        url_ = url_.replace("{accountRequestId}", encodeURIComponent("" + accountRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnblockRequest(_response);
        });
    }

    protected processUnblockRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRequests( cancelToken?: CancelToken): Promise<AccountRequestDto[]> {
        let url_ = this.baseUrl + "/api/accounts/requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequests(_response);
        });
    }

    protected processGetRequests(response: AxiosResponse): Promise<AccountRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AccountRequestDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountRequestDto[]>(null as any);
    }

    getBlockedRequests( cancelToken?: CancelToken): Promise<AccountRequestDto[]> {
        let url_ = this.baseUrl + "/api/accounts/requests/blocked";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBlockedRequests(_response);
        });
    }

    protected processGetBlockedRequests(response: AxiosResponse): Promise<AccountRequestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AccountRequestDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountRequestDto[]>(null as any);
    }

    getCurrentUserInfo( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/accounts/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserInfo(_response);
        });
    }

    protected processGetCurrentUserInfo(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getAccounts(getInactive?: boolean | undefined, cancelToken?: CancelToken): Promise<AccountDto[]> {
        let url_ = this.baseUrl + "/api/accounts/accounts?";
        if (getInactive === null)
            throw new globalThis.Error("The parameter 'getInactive' cannot be null.");
        else if (getInactive !== undefined)
            url_ += "getInactive=" + encodeURIComponent("" + getInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccounts(_response);
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AccountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto[]>(null as any);
    }

    register( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/accounts/register";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAccountInfo(accountId: string, cancelToken?: CancelToken): Promise<AccountInfoDto> {
        let url_ = this.baseUrl + "/api/accounts/account/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountInfo(_response);
        });
    }

    protected processGetAccountInfo(response: AxiosResponse): Promise<AccountInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AccountInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountInfoDto>(null as any);
    }

    getRoleInfos(accountId: string, cancelToken?: CancelToken): Promise<RoleInfoDto> {
        let url_ = this.baseUrl + "/api/accounts/role-info/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleInfos(_response);
        });
    }

    protected processGetRoleInfos(response: AxiosResponse): Promise<RoleInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RoleInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleInfoDto>(null as any);
    }

    checkEmail(userId?: string | null | undefined, email?: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/accounts/check-email?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmail(_response);
        });
    }

    protected processCheckEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    update(accountDto: AccountInfoDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(accountId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addRole(accountId: string, roleType: RoleType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/role/add/{accountId}/{roleType}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (roleType === undefined || roleType === null)
            throw new globalThis.Error("The parameter 'roleType' must be defined.");
        url_ = url_.replace("{roleType}", encodeURIComponent("" + roleType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRole(_response);
        });
    }

    protected processAddRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteRole(accountId: string, roleType: RoleType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/role/{accountId}/{roleType}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (roleType === undefined || roleType === null)
            throw new globalThis.Error("The parameter 'roleType' must be defined.");
        url_ = url_.replace("{roleType}", encodeURIComponent("" + roleType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activateRole(roleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/role/activate/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateRole(_response);
        });
    }

    protected processActivateRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deactivateRole(roleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/role/deactivate/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateRole(_response);
        });
    }

    protected processDeactivateRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addUas(roleId: string, uasId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/uas/add/{roleId}/{uasId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUas(_response);
        });
    }

    protected processAddUas(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeUas(roleId: string, uasId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/uas/remove/{roleId}/{uasId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUas(_response);
        });
    }

    protected processRemoveUas(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addLecturerFor(roleId: string, executionId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/lecturerfor/add/{roleId}/{executionId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (executionId === undefined || executionId === null)
            throw new globalThis.Error("The parameter 'executionId' must be defined.");
        url_ = url_.replace("{executionId}", encodeURIComponent("" + executionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddLecturerFor(_response);
        });
    }

    protected processAddLecturerFor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeLecturerFor(roleId: string, executionId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/accounts/lecturerfor/remove/{roleId}/{executionId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (executionId === undefined || executionId === null)
            throw new globalThis.Error("The parameter 'executionId' must be defined.");
        url_ = url_.replace("{executionId}", encodeURIComponent("" + executionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLecturerFor(_response);
        });
    }

    protected processRemoveLecturerFor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAuthClient {
    logIn( cancelToken?: CancelToken): Promise<void>;
    logOut( cancelToken?: CancelToken): Promise<FileResponse>;
    signInDev(email: string,  cancelToken?: CancelToken): Promise<FileResponse>;
    hello( cancelToken?: CancelToken): Promise<FileResponse>;
    helloAuthorized( cancelToken?: CancelToken): Promise<FileResponse>;
    helloAdmin( cancelToken?: CancelToken): Promise<FileResponse>;
}

export class AuthClient implements IAuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    logIn( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/login";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogIn(_response);
        });
    }

    protected processLogIn(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    logOut( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogOut(_response);
        });
    }

    protected processLogOut(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    signInDev(email: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/login/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignInDev(_response);
        });
    }

    protected processSignInDev(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hello( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHello(_response);
        });
    }

    protected processHello(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    helloAuthorized( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ping/authorized";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHelloAuthorized(_response);
        });
    }

    protected processHelloAuthorized(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    helloAdmin( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/ping/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHelloAdmin(_response);
        });
    }

    protected processHelloAdmin(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IResourceClient {
    getAllowedResources( cancelToken?: CancelToken): Promise<Resource[]>;
}

export class ResourceClient implements IResourceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getAllowedResources( cancelToken?: CancelToken): Promise<Resource[]> {
        let url_ = this.baseUrl + "/resources/allowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowedResources(_response);
        });
    }

    protected processGetAllowedResources(response: AxiosResponse): Promise<Resource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<Resource[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Resource[]>(null as any);
    }
}

export interface IModuleSelectionClient {
    getModuleExecution(moduleExecutionId?: number | undefined,  cancelToken?: CancelToken): Promise<ModuleExecutionDto>;
    getModuleExecutions(academicYearId?: number | undefined,  cancelToken?: CancelToken): Promise<ModuleExecutionDto[]>;
    getModuleStructure( cancelToken?: CancelToken): Promise<ModuleStructureDto>;
}

export class ModuleSelectionClient implements IModuleSelectionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getModuleExecution(moduleExecutionId?: number | undefined, cancelToken?: CancelToken): Promise<ModuleExecutionDto> {
        let url_ = this.baseUrl + "/api/selection/modules/execution?";
        if (moduleExecutionId === null)
            throw new globalThis.Error("The parameter 'moduleExecutionId' cannot be null.");
        else if (moduleExecutionId !== undefined)
            url_ += "moduleExecutionId=" + encodeURIComponent("" + moduleExecutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleExecution(_response);
        });
    }

    protected processGetModuleExecution(response: AxiosResponse): Promise<ModuleExecutionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleExecutionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleExecutionDto>(null as any);
    }

    getModuleExecutions(academicYearId?: number | undefined, cancelToken?: CancelToken): Promise<ModuleExecutionDto[]> {
        let url_ = this.baseUrl + "/api/selection/modules/academicYear?";
        if (academicYearId === null)
            throw new globalThis.Error("The parameter 'academicYearId' cannot be null.");
        else if (academicYearId !== undefined)
            url_ += "academicYearId=" + encodeURIComponent("" + academicYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleExecutions(_response);
        });
    }

    protected processGetModuleExecutions(response: AxiosResponse): Promise<ModuleExecutionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleExecutionDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleExecutionDto[]>(null as any);
    }

    getModuleStructure( cancelToken?: CancelToken): Promise<ModuleStructureDto> {
        let url_ = this.baseUrl + "/api/selection/modules/modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleStructure(_response);
        });
    }

    protected processGetModuleStructure(response: AxiosResponse): Promise<ModuleStructureDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleStructureDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleStructureDto>(null as any);
    }
}

export interface ISemesterSelectionClient {
    getSemesterSelectionFilter( cancelToken?: CancelToken): Promise<SemesterSelectionFilter>;
}

export class SemesterSelectionClient implements ISemesterSelectionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getSemesterSelectionFilter( cancelToken?: CancelToken): Promise<SemesterSelectionFilter> {
        let url_ = this.baseUrl + "/api/selection/semester/semester";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSemesterSelectionFilter(_response);
        });
    }

    protected processGetSemesterSelectionFilter(response: AxiosResponse): Promise<SemesterSelectionFilter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SemesterSelectionFilter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SemesterSelectionFilter>(null as any);
    }
}

export interface ISwaggerClient {
    getSwaggerResources( cancelToken?: CancelToken): Promise<SwaggerResourceDto[]>;
}

export class SwaggerClient implements ISwaggerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getSwaggerResources( cancelToken?: CancelToken): Promise<SwaggerResourceDto[]> {
        let url_ = this.baseUrl + "/swagger-resources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSwaggerResources(_response);
        });
    }

    protected processGetSwaggerResources(response: AxiosResponse): Promise<SwaggerResourceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SwaggerResourceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SwaggerResourceDto[]>(null as any);
    }
}

export interface IEmailClient {
    add(emailDto: EmailDto,  cancelToken?: CancelToken): Promise<number>;
    update(emailDto: EmailDto,  cancelToken?: CancelToken): Promise<void>;
    delete(emailId: number,  cancelToken?: CancelToken): Promise<void>;
    checkEmail(userId?: string | null | undefined, email?: string | null | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class EmailClient implements IEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    add(emailDto: EmailDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/emails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    update(emailDto: EmailDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/emails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(emailId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/emails/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new globalThis.Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    checkEmail(userId?: string | null | undefined, email?: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/emails/check-email?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmail(_response);
        });
    }

    protected processCheckEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IAdvisorClient {
    getAdvisorsWithNoUasRelation( cancelToken?: CancelToken): Promise<AdvisorDto[]>;
    list(uasId?: number | undefined,  cancelToken?: CancelToken): Promise<AdvisorDto[]>;
    search(search: PersonSearchDto,  cancelToken?: CancelToken): Promise<AdvisorDto[]>;
    add(advisorDto: AdvisorDto, uasId?: number | undefined,  cancelToken?: CancelToken): Promise<string>;
    update(advisorDto: AdvisorDto,  cancelToken?: CancelToken): Promise<void>;
    addUasRelation(userId?: string | null | undefined, uasId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    removeUasRelation(userId?: string | null | undefined, uasId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    delete(advisorId: string, uasId?: number | null | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AdvisorClient implements IAdvisorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getAdvisorsWithNoUasRelation( cancelToken?: CancelToken): Promise<AdvisorDto[]> {
        let url_ = this.baseUrl + "/api/advisors/no-uas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvisorsWithNoUasRelation(_response);
        });
    }

    protected processGetAdvisorsWithNoUasRelation(response: AxiosResponse): Promise<AdvisorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AdvisorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvisorDto[]>(null as any);
    }

    list(uasId?: number | undefined, cancelToken?: CancelToken): Promise<AdvisorDto[]> {
        let url_ = this.baseUrl + "/api/advisors/list?";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<AdvisorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AdvisorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvisorDto[]>(null as any);
    }

    search(search: PersonSearchDto, cancelToken?: CancelToken): Promise<AdvisorDto[]> {
        let url_ = this.baseUrl + "/api/advisors/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<AdvisorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AdvisorDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvisorDto[]>(null as any);
    }

    add(advisorDto: AdvisorDto, uasId?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/advisors?";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advisorDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    update(advisorDto: AdvisorDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/advisors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advisorDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addUasRelation(userId?: string | null | undefined, uasId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/advisors/add-uas-relation?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUasRelation(_response);
        });
    }

    protected processAddUasRelation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeUasRelation(userId?: string | null | undefined, uasId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/advisors/remove-uas-relation?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUasRelation(_response);
        });
    }

    protected processRemoveUasRelation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(advisorId: string, uasId?: number | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/advisors/{advisorId}?";
        if (advisorId === undefined || advisorId === null)
            throw new globalThis.Error("The parameter 'advisorId' must be defined.");
        url_ = url_.replace("{advisorId}", encodeURIComponent("" + advisorId));
        if (uasId !== undefined && uasId !== null)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUasClient {
    list( cancelToken?: CancelToken): Promise<UasDto[]>;
    add(uasDto: UasDto,  cancelToken?: CancelToken): Promise<number>;
    update(uasDto: UasDto,  cancelToken?: CancelToken): Promise<void>;
    delete(uasId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class UasClient implements IUasClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<UasDto[]> {
        let url_ = this.baseUrl + "/api/uas/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UasDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UasDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UasDto[]>(null as any);
    }

    add(uasDto: UasDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/uas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uasDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    update(uasDto: UasDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uasDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(uasId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uas/{uasId}";
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUasDomainClient {
    list( cancelToken?: CancelToken): Promise<UasDomainDto[]>;
    getForUas(uasId?: number | undefined,  cancelToken?: CancelToken): Promise<UasDomainDto[]>;
    addDomain(uasDomainDto: UasDomainDto,  cancelToken?: CancelToken): Promise<number>;
    updateDomain(uasDomainDto: UasDomainDto,  cancelToken?: CancelToken): Promise<void>;
    deleteDomain(domainId: number,  cancelToken?: CancelToken): Promise<void>;
    addToUas(uasId?: number | undefined, uasDomainId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    removeFromUas(uasId?: number | undefined, uasDomainId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class UasDomainClient implements IUasDomainClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<UasDomainDto[]> {
        let url_ = this.baseUrl + "/api/uas/domain/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UasDomainDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UasDomainDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UasDomainDto[]>(null as any);
    }

    getForUas(uasId?: number | undefined, cancelToken?: CancelToken): Promise<UasDomainDto[]> {
        let url_ = this.baseUrl + "/api/uas/domain/forUas?";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForUas(_response);
        });
    }

    protected processGetForUas(response: AxiosResponse): Promise<UasDomainDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UasDomainDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UasDomainDto[]>(null as any);
    }

    addDomain(uasDomainDto: UasDomainDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/uas/domain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uasDomainDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDomain(_response);
        });
    }

    protected processAddDomain(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateDomain(uasDomainDto: UasDomainDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uas/domain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uasDomainDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDomain(_response);
        });
    }

    protected processUpdateDomain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteDomain(domainId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uas/domain/{domainId}";
        if (domainId === undefined || domainId === null)
            throw new globalThis.Error("The parameter 'domainId' must be defined.");
        url_ = url_.replace("{domainId}", encodeURIComponent("" + domainId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDomain(_response);
        });
    }

    protected processDeleteDomain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addToUas(uasId?: number | undefined, uasDomainId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uas/domain/add-to-uas?";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        if (uasDomainId === null)
            throw new globalThis.Error("The parameter 'uasDomainId' cannot be null.");
        else if (uasDomainId !== undefined)
            url_ += "uasDomainId=" + encodeURIComponent("" + uasDomainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToUas(_response);
        });
    }

    protected processAddToUas(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeFromUas(uasId?: number | undefined, uasDomainId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/uas/domain/remove-from-uas?";
        if (uasId === null)
            throw new globalThis.Error("The parameter 'uasId' cannot be null.");
        else if (uasId !== undefined)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        if (uasDomainId === null)
            throw new globalThis.Error("The parameter 'uasDomainId' cannot be null.");
        else if (uasDomainId !== undefined)
            url_ += "uasDomainId=" + encodeURIComponent("" + uasDomainId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromUas(_response);
        });
    }

    protected processRemoveFromUas(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IExamRegistrationClient {
    isExamRegistrationOpen(semesterId: number,  cancelToken?: CancelToken): Promise<boolean>;
    getExamRegistrationsForSemester(semesterId: number, uasId?: number | null | undefined,  cancelToken?: CancelToken): Promise<ExamRegistrationDto[]>;
    addResitExamRegistration(moduleRegistrationId: number,  cancelToken?: CancelToken): Promise<ExamRegistrationDto>;
    withdrawExamRegistration(examRegistrationId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    deleteResitExamRegistration(examRegistrationId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    confirmExamRegistration(examRegistrationId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    getPreviousExamAttempts(moduleRegistrationId: number,  cancelToken?: CancelToken): Promise<PreviousExamAttemptDto[]>;
    exportExams(semesterId: number, uasId: number, type?: string | null | undefined, moduleId?: number | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    exportAllExams(semesterId: number, type?: string | null | undefined, moduleId?: number | null | undefined,  cancelToken?: CancelToken): Promise<FileResponse>;
    setOpeningDate(examRegistrationId: number, request: SetOpeningDateRequest,  cancelToken?: CancelToken): Promise<FileResponse>;
    cleanupOrphanedExamRegistrations( cancelToken?: CancelToken): Promise<number>;
}

export class ExamRegistrationClient implements IExamRegistrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    isExamRegistrationOpen(semesterId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/exam-registrations/is-open/{semesterId}";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsExamRegistrationOpen(_response);
        });
    }

    protected processIsExamRegistrationOpen(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getExamRegistrationsForSemester(semesterId: number, uasId?: number | null | undefined, cancelToken?: CancelToken): Promise<ExamRegistrationDto[]> {
        let url_ = this.baseUrl + "/api/exam-registrations/semester/{semesterId}?";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (uasId !== undefined && uasId !== null)
            url_ += "uasId=" + encodeURIComponent("" + uasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamRegistrationsForSemester(_response);
        });
    }

    protected processGetExamRegistrationsForSemester(response: AxiosResponse): Promise<ExamRegistrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExamRegistrationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamRegistrationDto[]>(null as any);
    }

    addResitExamRegistration(moduleRegistrationId: number, cancelToken?: CancelToken): Promise<ExamRegistrationDto> {
        let url_ = this.baseUrl + "/api/exam-registrations/{moduleRegistrationId}/resit";
        if (moduleRegistrationId === undefined || moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' must be defined.");
        url_ = url_.replace("{moduleRegistrationId}", encodeURIComponent("" + moduleRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddResitExamRegistration(_response);
        });
    }

    protected processAddResitExamRegistration(response: AxiosResponse): Promise<ExamRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExamRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamRegistrationDto>(null as any);
    }

    withdrawExamRegistration(examRegistrationId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-registrations/{examRegistrationId}/withdraw";
        if (examRegistrationId === undefined || examRegistrationId === null)
            throw new globalThis.Error("The parameter 'examRegistrationId' must be defined.");
        url_ = url_.replace("{examRegistrationId}", encodeURIComponent("" + examRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWithdrawExamRegistration(_response);
        });
    }

    protected processWithdrawExamRegistration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteResitExamRegistration(examRegistrationId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-registrations/{examRegistrationId}/resit";
        if (examRegistrationId === undefined || examRegistrationId === null)
            throw new globalThis.Error("The parameter 'examRegistrationId' must be defined.");
        url_ = url_.replace("{examRegistrationId}", encodeURIComponent("" + examRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResitExamRegistration(_response);
        });
    }

    protected processDeleteResitExamRegistration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    confirmExamRegistration(examRegistrationId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-registrations/{examRegistrationId}/confirm";
        if (examRegistrationId === undefined || examRegistrationId === null)
            throw new globalThis.Error("The parameter 'examRegistrationId' must be defined.");
        url_ = url_.replace("{examRegistrationId}", encodeURIComponent("" + examRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmExamRegistration(_response);
        });
    }

    protected processConfirmExamRegistration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPreviousExamAttempts(moduleRegistrationId: number, cancelToken?: CancelToken): Promise<PreviousExamAttemptDto[]> {
        let url_ = this.baseUrl + "/api/exam-registrations/{moduleRegistrationId}/previous-attempts";
        if (moduleRegistrationId === undefined || moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' must be defined.");
        url_ = url_.replace("{moduleRegistrationId}", encodeURIComponent("" + moduleRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreviousExamAttempts(_response);
        });
    }

    protected processGetPreviousExamAttempts(response: AxiosResponse): Promise<PreviousExamAttemptDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PreviousExamAttemptDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreviousExamAttemptDto[]>(null as any);
    }

    exportExams(semesterId: number, uasId: number, type?: string | null | undefined, moduleId?: number | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-registrations/export/{semesterId}/{uasId}?";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExams(_response);
        });
    }

    protected processExportExams(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportAllExams(semesterId: number, type?: string | null | undefined, moduleId?: number | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-registrations/export-all/{semesterId}?";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (moduleId !== undefined && moduleId !== null)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAllExams(_response);
        });
    }

    protected processExportAllExams(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setOpeningDate(examRegistrationId: number, request: SetOpeningDateRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/exam-registrations/{examRegistrationId}/opening-date";
        if (examRegistrationId === undefined || examRegistrationId === null)
            throw new globalThis.Error("The parameter 'examRegistrationId' must be defined.");
        url_ = url_.replace("{examRegistrationId}", encodeURIComponent("" + examRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOpeningDate(_response);
        });
    }

    protected processSetOpeningDate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cleanupOrphanedExamRegistrations( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/exam-registrations/cleanup-orphaned";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCleanupOrphanedExamRegistrations(_response);
        });
    }

    protected processCleanupOrphanedExamRegistrations(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IRegistrationFilterPresetClient {
    list( cancelToken?: CancelToken): Promise<FilterPresetDto[]>;
    update(preset: FilterPresetDto,  cancelToken?: CancelToken): Promise<void>;
    add(preset: FilterPresetDto,  cancelToken?: CancelToken): Promise<number>;
    delete(id: number,  cancelToken?: CancelToken): Promise<void>;
}

export class RegistrationFilterPresetClient implements IRegistrationFilterPresetClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<FilterPresetDto[]> {
        let url_ = this.baseUrl + "/api/registration/filter-preset/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FilterPresetDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FilterPresetDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterPresetDto[]>(null as any);
    }

    update(preset: FilterPresetDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration/filter-preset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preset);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    add(preset: FilterPresetDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/registration/filter-preset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(preset);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration/filter-preset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPriorityClient {
    list( cancelToken?: CancelToken): Promise<PriorityDto[]>;
    update(priorityDto: PriorityDto,  cancelToken?: CancelToken): Promise<void>;
    add(priorityDto: PriorityDto,  cancelToken?: CancelToken): Promise<PriorityDto>;
    delete(priorityId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class PriorityClient implements IPriorityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<PriorityDto[]> {
        let url_ = this.baseUrl + "/api/priority/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PriorityDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PriorityDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriorityDto[]>(null as any);
    }

    update(priorityDto: PriorityDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/priority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priorityDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    add(priorityDto: PriorityDto, cancelToken?: CancelToken): Promise<PriorityDto> {
        let url_ = this.baseUrl + "/api/priority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priorityDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<PriorityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PriorityDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriorityDto>(null as any);
    }

    delete(priorityId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/priority/{priorityId}";
        if (priorityId === undefined || priorityId === null)
            throw new globalThis.Error("The parameter 'priorityId' must be defined.");
        url_ = url_.replace("{priorityId}", encodeURIComponent("" + priorityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProfileClient {
    list( cancelToken?: CancelToken): Promise<ProfileDto[]>;
    update(profileDto: ProfileDto,  cancelToken?: CancelToken): Promise<void>;
    add(profileDto: ProfileDto,  cancelToken?: CancelToken): Promise<ProfileDto>;
    delete(profileId: number,  cancelToken?: CancelToken): Promise<void>;
    getPriorityAssignments(profileId: number, semesterId: number,  cancelToken?: CancelToken): Promise<PriorityAssignmentDto[]>;
    assignPriority(profileId?: number | undefined, moduleExecutionId?: number | undefined, priorityId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    removePriority(profileId?: number | undefined, moduleExecutionId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    removeAllPriorities(profileId?: number | undefined, semesterId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    assignAllPriorities(profileId?: number | undefined, semesterId?: number | undefined, priorityId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    assignPriorities(priorityAssignmentDtos: PriorityAssignmentDto[],  cancelToken?: CancelToken): Promise<void>;
    copySemester(profileId?: number | undefined, fromSemesterId?: number | undefined, toSemesterId?: number | undefined,  cancelToken?: CancelToken): Promise<PriorityAssignmentDto[]>;
}

export class ProfileClient implements IProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<ProfileDto[]> {
        let url_ = this.baseUrl + "/api/profile/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ProfileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProfileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileDto[]>(null as any);
    }

    update(profileDto: ProfileDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    add(profileDto: ProfileDto, cancelToken?: CancelToken): Promise<ProfileDto> {
        let url_ = this.baseUrl + "/api/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<ProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ProfileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileDto>(null as any);
    }

    delete(profileId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPriorityAssignments(profileId: number, semesterId: number, cancelToken?: CancelToken): Promise<PriorityAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/profile/priorities/{profileId}/{semesterId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriorityAssignments(_response);
        });
    }

    protected processGetPriorityAssignments(response: AxiosResponse): Promise<PriorityAssignmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PriorityAssignmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriorityAssignmentDto[]>(null as any);
    }

    assignPriority(profileId?: number | undefined, moduleExecutionId?: number | undefined, priorityId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile/priority/assign?";
        if (profileId === null)
            throw new globalThis.Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (moduleExecutionId === null)
            throw new globalThis.Error("The parameter 'moduleExecutionId' cannot be null.");
        else if (moduleExecutionId !== undefined)
            url_ += "moduleExecutionId=" + encodeURIComponent("" + moduleExecutionId) + "&";
        if (priorityId === null)
            throw new globalThis.Error("The parameter 'priorityId' cannot be null.");
        else if (priorityId !== undefined)
            url_ += "priorityId=" + encodeURIComponent("" + priorityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignPriority(_response);
        });
    }

    protected processAssignPriority(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removePriority(profileId?: number | undefined, moduleExecutionId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile/priority/remove?";
        if (profileId === null)
            throw new globalThis.Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (moduleExecutionId === null)
            throw new globalThis.Error("The parameter 'moduleExecutionId' cannot be null.");
        else if (moduleExecutionId !== undefined)
            url_ += "moduleExecutionId=" + encodeURIComponent("" + moduleExecutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemovePriority(_response);
        });
    }

    protected processRemovePriority(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeAllPriorities(profileId?: number | undefined, semesterId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile/priority/remove/all?";
        if (profileId === null)
            throw new globalThis.Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' cannot be null.");
        else if (semesterId !== undefined)
            url_ += "semesterId=" + encodeURIComponent("" + semesterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAllPriorities(_response);
        });
    }

    protected processRemoveAllPriorities(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignAllPriorities(profileId?: number | undefined, semesterId?: number | undefined, priorityId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile/priorities/assign/all?";
        if (profileId === null)
            throw new globalThis.Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' cannot be null.");
        else if (semesterId !== undefined)
            url_ += "semesterId=" + encodeURIComponent("" + semesterId) + "&";
        if (priorityId === null)
            throw new globalThis.Error("The parameter 'priorityId' cannot be null.");
        else if (priorityId !== undefined)
            url_ += "priorityId=" + encodeURIComponent("" + priorityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignAllPriorities(_response);
        });
    }

    protected processAssignAllPriorities(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignPriorities(priorityAssignmentDtos: PriorityAssignmentDto[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/profile/priorities/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priorityAssignmentDtos);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignPriorities(_response);
        });
    }

    protected processAssignPriorities(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copySemester(profileId?: number | undefined, fromSemesterId?: number | undefined, toSemesterId?: number | undefined, cancelToken?: CancelToken): Promise<PriorityAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/profile/priorities/copy-semester?";
        if (profileId === null)
            throw new globalThis.Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (fromSemesterId === null)
            throw new globalThis.Error("The parameter 'fromSemesterId' cannot be null.");
        else if (fromSemesterId !== undefined)
            url_ += "fromSemesterId=" + encodeURIComponent("" + fromSemesterId) + "&";
        if (toSemesterId === null)
            throw new globalThis.Error("The parameter 'toSemesterId' cannot be null.");
        else if (toSemesterId !== undefined)
            url_ += "toSemesterId=" + encodeURIComponent("" + toSemesterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopySemester(_response);
        });
    }

    protected processCopySemester(response: AxiosResponse): Promise<PriorityAssignmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<PriorityAssignmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriorityAssignmentDto[]>(null as any);
    }
}

export interface ISemesterManagementClient {
    copyAcademicYear(options: CopyAcademicYearOptionsDto,  cancelToken?: CancelToken): Promise<number>;
    copySemester(options: CopySemesterOptionsDto,  cancelToken?: CancelToken): Promise<number>;
    updateOrInsertSemester(semesterDto: SemesterInfoDto,  cancelToken?: CancelToken): Promise<number>;
    updateOrInsertPhase(phaseDto: PhaseDto,  cancelToken?: CancelToken): Promise<number>;
    deleteSemester(semesterId: number,  cancelToken?: CancelToken): Promise<void>;
    updateAcademicYear(academicYearDto: AcademicYearDto,  cancelToken?: CancelToken): Promise<void>;
    addAcademicYear(academicYearDto: AcademicYearDto,  cancelToken?: CancelToken): Promise<AcademicYearDto>;
    deleteAcademicYear(academicYearId: number,  cancelToken?: CancelToken): Promise<void>;
    closePhase(phaseId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    reopenPhase(phaseId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    deletePhase(phaseId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class SemesterManagementClient implements ISemesterManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    copyAcademicYear(options: CopyAcademicYearOptionsDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/semesters/academic-year/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyAcademicYear(_response);
        });
    }

    protected processCopyAcademicYear(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    copySemester(options: CopySemesterOptionsDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/semesters/semester/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopySemester(_response);
        });
    }

    protected processCopySemester(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateOrInsertSemester(semesterDto: SemesterInfoDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/semesters/semester/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(semesterDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrInsertSemester(_response);
        });
    }

    protected processUpdateOrInsertSemester(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateOrInsertPhase(phaseDto: PhaseDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/semesters/phase/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(phaseDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrInsertPhase(_response);
        });
    }

    protected processUpdateOrInsertPhase(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteSemester(semesterId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/semesters/semester/{semesterId}";
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSemester(_response);
        });
    }

    protected processDeleteSemester(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateAcademicYear(academicYearDto: AcademicYearDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/semesters/academic-year";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(academicYearDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAcademicYear(_response);
        });
    }

    protected processUpdateAcademicYear(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addAcademicYear(academicYearDto: AcademicYearDto, cancelToken?: CancelToken): Promise<AcademicYearDto> {
        let url_ = this.baseUrl + "/api/semesters/academic-year";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(academicYearDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddAcademicYear(_response);
        });
    }

    protected processAddAcademicYear(response: AxiosResponse): Promise<AcademicYearDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AcademicYearDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcademicYearDto>(null as any);
    }

    deleteAcademicYear(academicYearId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/semesters/academic-year/{academicYearId}";
        if (academicYearId === undefined || academicYearId === null)
            throw new globalThis.Error("The parameter 'academicYearId' must be defined.");
        url_ = url_.replace("{academicYearId}", encodeURIComponent("" + academicYearId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAcademicYear(_response);
        });
    }

    protected processDeleteAcademicYear(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    closePhase(phaseId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/semesters/phase/close?";
        if (phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClosePhase(_response);
        });
    }

    protected processClosePhase(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    reopenPhase(phaseId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/semesters/phase/reopen?";
        if (phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReopenPhase(_response);
        });
    }

    protected processReopenPhase(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deletePhase(phaseId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/semesters/phase/{phaseId}";
        if (phaseId === undefined || phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePhase(_response);
        });
    }

    protected processDeletePhase(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IImportClient {
    validate(semesterId?: number | undefined, excelFile?: FileParameter | null | undefined,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    revalidate(registrationImport: RegistrationImport,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    revalidateSubmitted(registrationImport: RegistrationImport,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    addFile(fileImportId?: number | undefined, excelFile?: FileParameter | null | undefined,  cancelToken?: CancelToken): Promise<FileImportDto>;
    submit(registrationImport: RegistrationImport,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    getUniversitiesOfAppliedScience( cancelToken?: CancelToken): Promise<UasDto[]>;
    countPendingImports( cancelToken?: CancelToken): Promise<number>;
    getPendingImports(academicYearId: number, semesterId: number | null, phaseId: number | null,  cancelToken?: CancelToken): Promise<FileImportDto[]>;
    getImports(academicYearId: number | null, semesterId: number | null, phaseId: number | null,  cancelToken?: CancelToken): Promise<FileImportDto[]>;
    getOriginalFile(id: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    getProcessedFile(id: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    getImport(id: number,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    import(id?: number | undefined,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    resetValidation(id?: number | undefined,  cancelToken?: CancelToken): Promise<RegistrationValidationDto>;
    reject(fileImportId?: number | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    withdraw(fileImportId?: number | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    delete(fileImportId: number,  cancelToken?: CancelToken): Promise<boolean>;
    moveToPhase(fileImportId?: number | undefined, phaseId?: number | undefined,  cancelToken?: CancelToken): Promise<boolean>;
}

export class ImportClient implements IImportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    validate(semesterId?: number | undefined, excelFile?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/validate?";
        if (semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' cannot be null.");
        else if (semesterId !== undefined)
            url_ += "semesterId=" + encodeURIComponent("" + semesterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    revalidate(registrationImport: RegistrationImport, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/revalidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationImport);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevalidate(_response);
        });
    }

    protected processRevalidate(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    revalidateSubmitted(registrationImport: RegistrationImport, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/revalidateSubmitted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationImport);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevalidateSubmitted(_response);
        });
    }

    protected processRevalidateSubmitted(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    addFile(fileImportId?: number | undefined, excelFile?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileImportDto> {
        let url_ = this.baseUrl + "/api/registration/import/add-file?";
        if (fileImportId === null)
            throw new globalThis.Error("The parameter 'fileImportId' cannot be null.");
        else if (fileImportId !== undefined)
            url_ += "fileImportId=" + encodeURIComponent("" + fileImportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFile(_response);
        });
    }

    protected processAddFile(response: AxiosResponse): Promise<FileImportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FileImportDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileImportDto>(null as any);
    }

    submit(registrationImport: RegistrationImport, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationImport);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    getUniversitiesOfAppliedScience( cancelToken?: CancelToken): Promise<UasDto[]> {
        let url_ = this.baseUrl + "/api/registration/import/uas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUniversitiesOfAppliedScience(_response);
        });
    }

    protected processGetUniversitiesOfAppliedScience(response: AxiosResponse): Promise<UasDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<UasDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UasDto[]>(null as any);
    }

    countPendingImports( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/registration/import/count-pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCountPendingImports(_response);
        });
    }

    protected processCountPendingImports(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getPendingImports(academicYearId: number, semesterId: number | null, phaseId: number | null, cancelToken?: CancelToken): Promise<FileImportDto[]> {
        let url_ = this.baseUrl + "/api/registration/import/pending/{academicYearId}/{semesterId}/{phaseId}";
        if (academicYearId === undefined || academicYearId === null)
            throw new globalThis.Error("The parameter 'academicYearId' must be defined.");
        url_ = url_.replace("{academicYearId}", encodeURIComponent("" + academicYearId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (phaseId === undefined || phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingImports(_response);
        });
    }

    protected processGetPendingImports(response: AxiosResponse): Promise<FileImportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FileImportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileImportDto[]>(null as any);
    }

    getImports(academicYearId: number | null, semesterId: number | null, phaseId: number | null, cancelToken?: CancelToken): Promise<FileImportDto[]> {
        let url_ = this.baseUrl + "/api/registration/import/file-imports/{academicYearId}/{semesterId}/{phaseId}";
        if (academicYearId === undefined || academicYearId === null)
            throw new globalThis.Error("The parameter 'academicYearId' must be defined.");
        url_ = url_.replace("{academicYearId}", encodeURIComponent("" + academicYearId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (phaseId === undefined || phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' must be defined.");
        url_ = url_.replace("{phaseId}", encodeURIComponent("" + phaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImports(_response);
        });
    }

    protected processGetImports(response: AxiosResponse): Promise<FileImportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<FileImportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileImportDto[]>(null as any);
    }

    getOriginalFile(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/import/original-file/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOriginalFile(_response);
        });
    }

    protected processGetOriginalFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getProcessedFile(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/import/processed-file/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessedFile(_response);
        });
    }

    protected processGetProcessedFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getImport(id: number, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/get-import/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImport(_response);
        });
    }

    protected processGetImport(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    import(id?: number | undefined, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/import?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    resetValidation(id?: number | undefined, cancelToken?: CancelToken): Promise<RegistrationValidationDto> {
        let url_ = this.baseUrl + "/api/registration/import/resetValidation?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetValidation(_response);
        });
    }

    protected processResetValidation(response: AxiosResponse): Promise<RegistrationValidationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationValidationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationValidationDto>(null as any);
    }

    reject(fileImportId?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/registration/import/reject?";
        if (fileImportId === null)
            throw new globalThis.Error("The parameter 'fileImportId' cannot be null.");
        else if (fileImportId !== undefined)
            url_ += "fileImportId=" + encodeURIComponent("" + fileImportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    withdraw(fileImportId?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/registration/import/withdraw?";
        if (fileImportId === null)
            throw new globalThis.Error("The parameter 'fileImportId' cannot be null.");
        else if (fileImportId !== undefined)
            url_ += "fileImportId=" + encodeURIComponent("" + fileImportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWithdraw(_response);
        });
    }

    protected processWithdraw(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    delete(fileImportId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/registration/import/{fileImportId}";
        if (fileImportId === undefined || fileImportId === null)
            throw new globalThis.Error("The parameter 'fileImportId' must be defined.");
        url_ = url_.replace("{fileImportId}", encodeURIComponent("" + fileImportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    moveToPhase(fileImportId?: number | undefined, phaseId?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/registration/import/move?";
        if (fileImportId === null)
            throw new globalThis.Error("The parameter 'fileImportId' cannot be null.");
        else if (fileImportId !== undefined)
            url_ += "fileImportId=" + encodeURIComponent("" + fileImportId) + "&";
        if (phaseId === null)
            throw new globalThis.Error("The parameter 'phaseId' cannot be null.");
        else if (phaseId !== undefined)
            url_ += "phaseId=" + encodeURIComponent("" + phaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveToPhase(_response);
        });
    }

    protected processMoveToPhase(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface IRegistrationExportClient {
    getStaticFilters( cancelToken?: CancelToken): Promise<StaticRegistrationFilterDto>;
    getModuleExecutionCodes(filterSelection: RegistrationFilterSelectionDto,  cancelToken?: CancelToken): Promise<string[]>;
    getFileImportSelection(filterSelection: RegistrationFilterSelectionDto,  cancelToken?: CancelToken): Promise<SelectionOfLong[]>;
    exportRegistrations(filterSelection: RegistrationFilterSelectionDto,  cancelToken?: CancelToken): Promise<FileResponse>;
    getRegistrationExportPreview(filterSelection: RegistrationFilterSelectionDto,  cancelToken?: CancelToken): Promise<ModuleRegistrationInfoDto[]>;
    exportRegistrationsForUas(uasId: number, semesterId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    exportRegistrationsForModuleExecution(moduleExecutionId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    exportRegistrationsForStudent(studentId: string, semesterId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    exportRegistrationsForStudent2(studentId: string, semesterId: number, uasId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
}

export class RegistrationExportClient implements IRegistrationExportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getStaticFilters( cancelToken?: CancelToken): Promise<StaticRegistrationFilterDto> {
        let url_ = this.baseUrl + "/api/registration/export/static-filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStaticFilters(_response);
        });
    }

    protected processGetStaticFilters(response: AxiosResponse): Promise<StaticRegistrationFilterDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StaticRegistrationFilterDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaticRegistrationFilterDto>(null as any);
    }

    getModuleExecutionCodes(filterSelection: RegistrationFilterSelectionDto, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/registration/export/execution-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSelection);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleExecutionCodes(_response);
        });
    }

    protected processGetModuleExecutionCodes(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getFileImportSelection(filterSelection: RegistrationFilterSelectionDto, cancelToken?: CancelToken): Promise<SelectionOfLong[]> {
        let url_ = this.baseUrl + "/api/registration/export/file-imports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSelection);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileImportSelection(_response);
        });
    }

    protected processGetFileImportSelection(response: AxiosResponse): Promise<SelectionOfLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SelectionOfLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectionOfLong[]>(null as any);
    }

    exportRegistrations(filterSelection: RegistrationFilterSelectionDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/export/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSelection);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrations(_response);
        });
    }

    protected processExportRegistrations(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRegistrationExportPreview(filterSelection: RegistrationFilterSelectionDto, cancelToken?: CancelToken): Promise<ModuleRegistrationInfoDto[]> {
        let url_ = this.baseUrl + "/api/registration/export/export-preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSelection);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationExportPreview(_response);
        });
    }

    protected processGetRegistrationExportPreview(response: AxiosResponse): Promise<ModuleRegistrationInfoDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationInfoDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationInfoDto[]>(null as any);
    }

    exportRegistrationsForUas(uasId: number, semesterId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/export/uas/{uasId}/{semesterId}";
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationsForUas(_response);
        });
    }

    protected processExportRegistrationsForUas(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportRegistrationsForModuleExecution(moduleExecutionId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/export/module/{moduleExecutionId}";
        if (moduleExecutionId === undefined || moduleExecutionId === null)
            throw new globalThis.Error("The parameter 'moduleExecutionId' must be defined.");
        url_ = url_.replace("{moduleExecutionId}", encodeURIComponent("" + moduleExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationsForModuleExecution(_response);
        });
    }

    protected processExportRegistrationsForModuleExecution(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportRegistrationsForStudent(studentId: string, semesterId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/export/module/{studentId}/{semesterId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationsForStudent(_response);
        });
    }

    protected processExportRegistrationsForStudent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportRegistrationsForStudent2(studentId: string, semesterId: number, uasId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/registration/export/student/{studentId}/{semesterId}/{uasId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (semesterId === undefined || semesterId === null)
            throw new globalThis.Error("The parameter 'semesterId' must be defined.");
        url_ = url_.replace("{semesterId}", encodeURIComponent("" + semesterId));
        if (uasId === undefined || uasId === null)
            throw new globalThis.Error("The parameter 'uasId' must be defined.");
        url_ = url_.replace("{uasId}", encodeURIComponent("" + uasId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRegistrationsForStudent2(_response);
        });
    }

    protected processExportRegistrationsForStudent2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IRuleClient {
    getRules( cancelToken?: CancelToken): Promise<RuleGroupInfo[]>;
    validateDebug( cancelToken?: CancelToken): Promise<string[]>;
    validate( cancelToken?: CancelToken): Promise<string[]>;
}

export class RuleClient implements IRuleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getRules( cancelToken?: CancelToken): Promise<RuleGroupInfo[]> {
        let url_ = this.baseUrl + "/api/rules/docs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRules(_response);
        });
    }

    protected processGetRules(response: AxiosResponse): Promise<RuleGroupInfo[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RuleGroupInfo[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleGroupInfo[]>(null as any);
    }

    validateDebug( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/rules/docs/validate-debug";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateDebug(_response);
        });
    }

    protected processValidateDebug(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    validate( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/rules/docs/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IExcelTemplateClient {
    list( cancelToken?: CancelToken): Promise<ExcelTemplateDto[]>;
    delete(id: number,  cancelToken?: CancelToken): Promise<void>;
    download(templateId: number,  cancelToken?: CancelToken): Promise<FileResponse>;
    upload(templateId?: number | undefined, file?: FileParameter | null | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ExcelTemplateClient implements IExcelTemplateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<ExcelTemplateDto[]> {
        let url_ = this.baseUrl + "/api/excel-template/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ExcelTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ExcelTemplateDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcelTemplateDto[]>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/excel-template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    download(templateId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/excel-template/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upload(templateId?: number | undefined, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/excel-template/upload?";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ILabelClient {
    list( cancelToken?: CancelToken): Promise<LabelDto[]>;
    update(labelDto: LabelDto,  cancelToken?: CancelToken): Promise<void>;
    add(labelDto: LabelDto,  cancelToken?: CancelToken): Promise<LabelDto>;
    delete(labelId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class LabelClient implements ILabelClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    list( cancelToken?: CancelToken): Promise<LabelDto[]> {
        let url_ = this.baseUrl + "/api/label/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<LabelDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LabelDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabelDto[]>(null as any);
    }

    update(labelDto: LabelDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/label";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(labelDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    add(labelDto: LabelDto, cancelToken?: CancelToken): Promise<LabelDto> {
        let url_ = this.baseUrl + "/api/label";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(labelDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<LabelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LabelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LabelDto>(null as any);
    }

    delete(labelId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/label/{labelId}";
        if (labelId === undefined || labelId === null)
            throw new globalThis.Error("The parameter 'labelId' must be defined.");
        url_ = url_.replace("{labelId}", encodeURIComponent("" + labelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IModuleManagementClient {
    copyAcademicYear(options: CopyModuleStructureDto,  cancelToken?: CancelToken): Promise<void>;
    copyModule(options: CopyModuleDto,  cancelToken?: CancelToken): Promise<void>;
    insertOrUpdateCategory(moduleCategoryDto: ModuleCategoryDto,  cancelToken?: CancelToken): Promise<ModuleCategoryDto>;
    deleteCategory(id: number,  cancelToken?: CancelToken): Promise<void>;
    insertModule(moduleDto: ModuleDto,  cancelToken?: CancelToken): Promise<ModuleDto>;
    updateModule(moduleDto: ModuleDto,  cancelToken?: CancelToken): Promise<ModuleDto>;
    deleteModule(id: number,  cancelToken?: CancelToken): Promise<void>;
    updateModuleExecutions(executionDtos: ModuleExecutionDto[], moduleId?: number | undefined, academicYearId?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    deleteModuleExecution(id: number,  cancelToken?: CancelToken): Promise<void>;
    insertOrUpdateLocation(locationDto: LocationDto,  cancelToken?: CancelToken): Promise<LocationDto>;
    deleteLocation(id: number,  cancelToken?: CancelToken): Promise<void>;
}

export class ModuleManagementClient implements IModuleManagementClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    copyAcademicYear(options: CopyModuleStructureDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/module-structure/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyAcademicYear(_response);
        });
    }

    protected processCopyAcademicYear(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copyModule(options: CopyModuleDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/module/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyModule(_response);
        });
    }

    protected processCopyModule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    insertOrUpdateCategory(moduleCategoryDto: ModuleCategoryDto, cancelToken?: CancelToken): Promise<ModuleCategoryDto> {
        let url_ = this.baseUrl + "/api/modules/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleCategoryDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertOrUpdateCategory(_response);
        });
    }

    protected processInsertOrUpdateCategory(response: AxiosResponse): Promise<ModuleCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleCategoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleCategoryDto>(null as any);
    }

    deleteCategory(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/category/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCategory(_response);
        });
    }

    protected processDeleteCategory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    insertModule(moduleDto: ModuleDto, cancelToken?: CancelToken): Promise<ModuleDto> {
        let url_ = this.baseUrl + "/api/modules/module/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertModule(_response);
        });
    }

    protected processInsertModule(response: AxiosResponse): Promise<ModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleDto>(null as any);
    }

    updateModule(moduleDto: ModuleDto, cancelToken?: CancelToken): Promise<ModuleDto> {
        let url_ = this.baseUrl + "/api/modules/module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModule(_response);
        });
    }

    protected processUpdateModule(response: AxiosResponse): Promise<ModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleDto>(null as any);
    }

    deleteModule(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/module/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModule(_response);
        });
    }

    protected processDeleteModule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateModuleExecutions(executionDtos: ModuleExecutionDto[], moduleId?: number | undefined, academicYearId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/module/executions?";
        if (moduleId === null)
            throw new globalThis.Error("The parameter 'moduleId' cannot be null.");
        else if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        if (academicYearId === null)
            throw new globalThis.Error("The parameter 'academicYearId' cannot be null.");
        else if (academicYearId !== undefined)
            url_ += "academicYearId=" + encodeURIComponent("" + academicYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(executionDtos);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModuleExecutions(_response);
        });
    }

    protected processUpdateModuleExecutions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteModuleExecution(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/module-execution/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModuleExecution(_response);
        });
    }

    protected processDeleteModuleExecution(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    insertOrUpdateLocation(locationDto: LocationDto, cancelToken?: CancelToken): Promise<LocationDto> {
        let url_ = this.baseUrl + "/api/modules/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locationDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertOrUpdateLocation(_response);
        });
    }

    protected processInsertOrUpdateLocation(response: AxiosResponse): Promise<LocationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LocationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationDto>(null as any);
    }

    deleteLocation(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/location/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRegistrationEditClient {
    getHistory(moduleRegistrationId: number,  cancelToken?: CancelToken): Promise<RegistrationStateChangeDto[]>;
    updateSemesterRegistration(semesterRegistrationDto: SemesterRegistrationDto,  cancelToken?: CancelToken): Promise<SemesterRegistrationDto>;
    addSemesterRegistration(semesterRegistrationDto: SemesterRegistrationDto,  cancelToken?: CancelToken): Promise<SemesterRegistrationDto>;
    deleteSemesterRegistration(semesterRegistrationId: number,  cancelToken?: CancelToken): Promise<void>;
    updateModuleRegistration(moduleRegistrationDto: ModuleRegistrationDto,  cancelToken?: CancelToken): Promise<ModuleRegistrationDto>;
    addModuleRegistration(moduleRegistrationDto: ModuleRegistrationDto,  cancelToken?: CancelToken): Promise<ModuleRegistrationDto>;
    deleteModuleRegistration(moduleRegistrationId: number,  cancelToken?: CancelToken): Promise<void>;
    withdrawModuleRegistration(moduleRegistrationId?: number | undefined, comment?: string | null | undefined,  cancelToken?: CancelToken): Promise<ModuleRegistrationDto>;
    requestModuleRegistration(moduleRegistrationId?: number | undefined, comment?: string | null | undefined,  cancelToken?: CancelToken): Promise<ModuleRegistrationDto>;
    addComment(comment: CommentDto,  cancelToken?: CancelToken): Promise<number>;
    deleteComment(commentId: number,  cancelToken?: CancelToken): Promise<void>;
    isRegistered(studentId?: string | null | undefined, moduleExecutionId?: number | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    getModuleRegistration(moduleRegistrationId: number,  cancelToken?: CancelToken): Promise<ModuleRegistrationInfoDto>;
}

export class RegistrationEditClient implements IRegistrationEditClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getHistory(moduleRegistrationId: number, cancelToken?: CancelToken): Promise<RegistrationStateChangeDto[]> {
        let url_ = this.baseUrl + "/api/registration-edit/history/{moduleRegistrationId}";
        if (moduleRegistrationId === undefined || moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' must be defined.");
        url_ = url_.replace("{moduleRegistrationId}", encodeURIComponent("" + moduleRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: AxiosResponse): Promise<RegistrationStateChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RegistrationStateChangeDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationStateChangeDto[]>(null as any);
    }

    updateSemesterRegistration(semesterRegistrationDto: SemesterRegistrationDto, cancelToken?: CancelToken): Promise<SemesterRegistrationDto> {
        let url_ = this.baseUrl + "/api/registration-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(semesterRegistrationDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSemesterRegistration(_response);
        });
    }

    protected processUpdateSemesterRegistration(response: AxiosResponse): Promise<SemesterRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SemesterRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SemesterRegistrationDto>(null as any);
    }

    addSemesterRegistration(semesterRegistrationDto: SemesterRegistrationDto, cancelToken?: CancelToken): Promise<SemesterRegistrationDto> {
        let url_ = this.baseUrl + "/api/registration-edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(semesterRegistrationDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSemesterRegistration(_response);
        });
    }

    protected processAddSemesterRegistration(response: AxiosResponse): Promise<SemesterRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SemesterRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SemesterRegistrationDto>(null as any);
    }

    deleteSemesterRegistration(semesterRegistrationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration-edit/{semesterRegistrationId}";
        if (semesterRegistrationId === undefined || semesterRegistrationId === null)
            throw new globalThis.Error("The parameter 'semesterRegistrationId' must be defined.");
        url_ = url_.replace("{semesterRegistrationId}", encodeURIComponent("" + semesterRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSemesterRegistration(_response);
        });
    }

    protected processDeleteSemesterRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateModuleRegistration(moduleRegistrationDto: ModuleRegistrationDto, cancelToken?: CancelToken): Promise<ModuleRegistrationDto> {
        let url_ = this.baseUrl + "/api/registration-edit/module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleRegistrationDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModuleRegistration(_response);
        });
    }

    protected processUpdateModuleRegistration(response: AxiosResponse): Promise<ModuleRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationDto>(null as any);
    }

    addModuleRegistration(moduleRegistrationDto: ModuleRegistrationDto, cancelToken?: CancelToken): Promise<ModuleRegistrationDto> {
        let url_ = this.baseUrl + "/api/registration-edit/module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleRegistrationDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddModuleRegistration(_response);
        });
    }

    protected processAddModuleRegistration(response: AxiosResponse): Promise<ModuleRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationDto>(null as any);
    }

    deleteModuleRegistration(moduleRegistrationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration-edit/module/{moduleRegistrationId}";
        if (moduleRegistrationId === undefined || moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' must be defined.");
        url_ = url_.replace("{moduleRegistrationId}", encodeURIComponent("" + moduleRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModuleRegistration(_response);
        });
    }

    protected processDeleteModuleRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    withdrawModuleRegistration(moduleRegistrationId?: number | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<ModuleRegistrationDto> {
        let url_ = this.baseUrl + "/api/registration-edit/module/withdraw?";
        if (moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' cannot be null.");
        else if (moduleRegistrationId !== undefined)
            url_ += "moduleRegistrationId=" + encodeURIComponent("" + moduleRegistrationId) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWithdrawModuleRegistration(_response);
        });
    }

    protected processWithdrawModuleRegistration(response: AxiosResponse): Promise<ModuleRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationDto>(null as any);
    }

    requestModuleRegistration(moduleRegistrationId?: number | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<ModuleRegistrationDto> {
        let url_ = this.baseUrl + "/api/registration-edit/module/request?";
        if (moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' cannot be null.");
        else if (moduleRegistrationId !== undefined)
            url_ += "moduleRegistrationId=" + encodeURIComponent("" + moduleRegistrationId) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestModuleRegistration(_response);
        });
    }

    protected processRequestModuleRegistration(response: AxiosResponse): Promise<ModuleRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationDto>(null as any);
    }

    addComment(comment: CommentDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/registration-edit/module/comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddComment(_response);
        });
    }

    protected processAddComment(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteComment(commentId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/registration-edit/module/comment/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    isRegistered(studentId?: string | null | undefined, moduleExecutionId?: number | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/registration-edit/isRegistered?";
        if (studentId !== undefined && studentId !== null)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (moduleExecutionId === null)
            throw new globalThis.Error("The parameter 'moduleExecutionId' cannot be null.");
        else if (moduleExecutionId !== undefined)
            url_ += "moduleExecutionId=" + encodeURIComponent("" + moduleExecutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsRegistered(_response);
        });
    }

    protected processIsRegistered(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getModuleRegistration(moduleRegistrationId: number, cancelToken?: CancelToken): Promise<ModuleRegistrationInfoDto> {
        let url_ = this.baseUrl + "/api/registration-edit/info/{moduleRegistrationId}";
        if (moduleRegistrationId === undefined || moduleRegistrationId === null)
            throw new globalThis.Error("The parameter 'moduleRegistrationId' must be defined.");
        url_ = url_.replace("{moduleRegistrationId}", encodeURIComponent("" + moduleRegistrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModuleRegistration(_response);
        });
    }

    protected processGetModuleRegistration(response: AxiosResponse): Promise<ModuleRegistrationInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ModuleRegistrationInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModuleRegistrationInfoDto>(null as any);
    }
}

export interface IStudentClient {
    search(search: PersonSearchDto,  cancelToken?: CancelToken): Promise<StudentPreviewDto[]>;
    getStudent(studentId?: string | null | undefined,  cancelToken?: CancelToken): Promise<StudentDto>;
    updateStudent(studentDto: StudentDto,  cancelToken?: CancelToken): Promise<void>;
    addStudent(studentDto: StudentDto,  cancelToken?: CancelToken): Promise<string>;
    deleteStudent(studentId: string,  cancelToken?: CancelToken): Promise<void>;
    addComment(comment: CommentDto,  cancelToken?: CancelToken): Promise<void>;
    deleteComment(commentId: number,  cancelToken?: CancelToken): Promise<void>;
}

export class StudentClient implements IStudentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    search(search: PersonSearchDto, cancelToken?: CancelToken): Promise<StudentPreviewDto[]> {
        let url_ = this.baseUrl + "/api/students/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<StudentPreviewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentPreviewDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentPreviewDto[]>(null as any);
    }

    getStudent(studentId?: string | null | undefined, cancelToken?: CancelToken): Promise<StudentDto> {
        let url_ = this.baseUrl + "/api/students/student?";
        if (studentId !== undefined && studentId !== null)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudent(_response);
        });
    }

    protected processGetStudent(response: AxiosResponse): Promise<StudentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<StudentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentDto>(null as any);
    }

    updateStudent(studentDto: StudentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/students";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudent(_response);
        });
    }

    protected processUpdateStudent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addStudent(studentDto: StudentDto, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/students";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(studentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddStudent(_response);
        });
    }

    protected processAddStudent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deleteStudent(studentId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/students/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStudent(_response);
        });
    }

    protected processDeleteStudent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addComment(comment: CommentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/students/comment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddComment(_response);
        });
    }

    protected processAddComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteComment(commentId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/students/comment/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface RoleDto {
    id: string | undefined;
    roleType: RoleType;
    name: string | undefined;
}

export enum RoleType {
    SYSTEM = "SYSTEM",
    ADMIN = "ADMIN",
    USERADMIN = "USERADMIN",
    PROCESSADMIN = "PROCESSADMIN",
    MODULEADMIN = "MODULEADMIN",
    PROFILEADMIN = "PROFILEADMIN",
    STUDENTADMIN = "STUDENTADMIN",
    REGISTRATIONADMIN = "REGISTRATIONADMIN",
    MASTEROFFICE = "MASTEROFFICE",
    ADVISOR = "ADVISOR",
    LECTURER = "LECTURER",
    STUDENT = "STUDENT",
    USER = "USER",
}

export interface ApplicationProfileDto {
    displayRibbonOnProfiles: string | undefined;
    activeProfiles: string[] | undefined;
    examRegistrationEnabled: boolean;
}

export interface RegistrationStateChangeDto {
    id: number;
    date: string;
    newState: RegistrationState;
    phase: string | undefined;
    phaseId: number | undefined;
    fileImportId: number | undefined;
    fileImport: string | undefined;
    uploadedById: string | undefined;
    uploadedBy: string | undefined;
    createdById: string | undefined;
    createdBy: string | undefined;
    oldState: RegistrationState;
    uploadedDate: string | undefined;
    comment: string | undefined;
    registrationId: number;
    isExamRegistrationChange: boolean;
    examNewState: string | undefined;
    changeType: ChangeType;
}

export enum RegistrationState {
    REQUESTED = "REQUESTED",
    ABSENTEX = "ABSENTEX",
    CONFIRMED = "CONFIRMED",
    NOT_REGISTERED = "NOT_REGISTERED",
    CANCELED = "CANCELED",
    WITHDRAWN = "WITHDRAWN",
    REJECTED = "REJECTED",
}

export enum ChangeType {
    FileImport = "FileImport",
    Prioritization = "Prioritization",
    Manual = "Manual",
    ManualByAdmin = "ManualByAdmin",
}

export interface PhaseCapacityDto {
    confirmedCount: number;
    currentCapacity: number;
    free: number;
    fullCapacity: number;
    moduleExecutionId: number;
    requestedCount: number;
    reservePercentage: number;
    phaseId: number | undefined;
    waitingCount: number;
}

export interface ModuleRegistrationsDto {
    confirmed: ModuleRegistrationInfoDto[] | undefined;
    requested: ModuleRegistrationInfoDto[] | undefined;
    others: ModuleRegistrationInfoDto[] | undefined;
    fullCapacity: number;
    freeCapacity: number;
    reservePercentage: number;
    currentCapacity: number;
}

export interface ModuleRegistrationDto {
    state: RegistrationState;
    moduleExecutionId: number;
    moduleId: number;
    moduleExecution: string | undefined;
    semesterRegistrationId: number;
    studentId: string | undefined;
    studentFamilyName: string | undefined;
    studentFirstName: string | undefined;
    dateOfRegistration: string;
    matriculationNumber: string | undefined;
    module: string | undefined;
    moduleCategory: string | undefined;
    specialLabelId: number | undefined;
    labelId: number | undefined;
    label: string | undefined;
    compensationForDisadvantages: boolean;
    hasSpecialLabel: boolean;
    id: number;
    internalComment: string | undefined;
    comment: string | undefined;
    changeType: ChangeType;
    lastStateUpdateComment: string | undefined;
    fileImport: string | undefined;
    comments: CommentDto[] | undefined;
    history: RegistrationStateChangeDto[] | undefined;
    createdDate: string;
}

export interface ModuleRegistrationInfoDto extends ModuleRegistrationDto {
    profileId: number;
    profile: string | undefined;
    semester: string | undefined;
    academicYear: string | undefined;
    uas: string | undefined;
    advisorId: string | undefined;
    advisorFirstName: string | undefined;
    advisorFamilyName: string | undefined;
    degree: string | undefined;
    birthDate: string | undefined;
    lastModifiedDate: string;
    location: string | undefined;
    semesterId: number;
    priority: string | undefined;
    priorityWeighting: number;
    priorityColor: string | undefined;
    advisorEmail: string | undefined;
    studentUASEmail: string | undefined;
    studentPrivateEmail: string | undefined;
    internalStudentComment: string | undefined;
    studentComment: string | undefined;
    isSelected: boolean;
    priorityValue: number;
    rank: number;
    uploadedBy: string | undefined;
    uploadedDate: string | undefined;
    importedBy: string | undefined;
    importedDate: string | undefined;
    requestedDate: string;
    requestedInPhase: string | undefined;
    confirmedDate: string | undefined;
    confirmedInPhase: string | undefined;
    lastStateChangeDate: string | undefined;
    lastStateChangeInPhase: string | undefined;
    isRegistration: boolean;
    isDeregistration: boolean;
    studentType: StudentType;
}

export enum StudentType {
    Student = "Student",
    Erasmus = "Erasmus",
    Incoming = "Incoming",
    GuestAuditor = "GuestAuditor",
    Unknown = "Unknown",
    Exchange = "Exchange",
}

export interface CommentDto {
    id: number;
    answerToId: number | undefined;
    comment: string | undefined;
    isInternal: boolean;
    createdBy: string | undefined;
    createdDate: string;
    showInOverview: boolean;
    registrationId: number | undefined;
    fileImportId: number | undefined;
    userId: string | undefined;
    createdById: string | undefined;
}

export interface SummaryFilterDto {
    semesters: SemesterSummaryFilterDto[] | undefined;
    untilDate: string | undefined;
}

export interface SemesterSummaryFilterDto {
    id: number;
    phaseId: number | undefined;
}

export interface AccountDto {
    firstName: string | undefined;
    familyName: string | undefined;
    id: string | undefined;
    email: string | undefined;
    roles: RoleType[] | undefined;
    activated: boolean;
    createdDate: string;
    createdById: string | undefined;
    createdBy: string | undefined;
    lastModifiedById: string | undefined;
    lastModifiedBy: string | undefined;
    lastModifiedDate: string;
}

export interface AccountRequestDto {
    id: number;
    firstName: string | undefined;
    familyName: string | undefined;
    createdDate: string;
    email: string | undefined;
    isBlocked: boolean;
}

export interface UserDto {
    isAuthenticated: boolean;
    firstName: string | undefined;
    lastName: string | undefined;
    roles: RoleType[] | undefined;
    email: string | undefined;
    id: string | undefined;
    isNew: boolean;
    hasRegistration: boolean;
    allowedUas: UasDto[] | undefined;
}

export interface UasDto {
    id: number;
    code: string | undefined;
    isActive: boolean;
    hasDependentData: boolean;
}

export interface AccountInfoDto extends AccountDto {
    emails: EmailDto[] | undefined;
    hasRoles: boolean;
}

export interface EmailDto {
    id: number;
    userId: string | undefined;
    name: string | undefined;
    isActive: boolean;
    isEduIdEmail: boolean;
    isPrivate: boolean;
    isDefault: boolean;
}

export interface RoleInfoDto {
    userId: string | undefined;
    lecturerRole: LecturerRoleDto | undefined;
    advisorRole: AdvisorRoleDto | undefined;
    masterOfficeRole: MasterOfficeRoleDto | undefined;
    otherRoles: UserRoleDto[] | undefined;
}

export interface UserRoleDto {
    id: string | undefined;
    userId: string | undefined;
    isActive: boolean;
    createdBy: string | undefined;
    createdById: string | undefined;
    lastModifiedBy: string | undefined;
    lastModifiedById: string | undefined;
    createdDate: string;
    lastModifiedDate: string;
    roleType: RoleType;
    hasRelations: boolean;
    name: string | undefined;
}

export interface LecturerRoleDto extends UserRoleDto {
    forModules: LecturerForDto[] | undefined;
}

export interface LecturerForDto {
    categoryId: number;
    moduleId: number;
    id: number;
    code: string | undefined;
    semester: string | undefined;
    location: string | undefined;
}

export interface AdvisorRoleDto extends UserRoleDto {
    forUas: UasDto[] | undefined;
}

export interface MasterOfficeRoleDto extends UserRoleDto {
    forUas: UasDto[] | undefined;
}

export enum Resource {
    MODULE_REGISTRATION_IMPORT = "MODULE_REGISTRATION_IMPORT",
    MODULE_REGISTRATION_VALIDATION = "MODULE_REGISTRATION_VALIDATION",
    MODULE_REGISTRATION_EXPORT = "MODULE_REGISTRATION_EXPORT",
    SEMESTER_REGISTRATION_IMPORT = "SEMESTER_REGISTRATION_IMPORT",
    SEMESTER_REGISTRATION_VALIDATION = "SEMESTER_REGISTRATION_VALIDATION",
    SEMESTER_REGISTRATION = "SEMESTER_REGISTRATION",
    STUDENT_ADMINISTRATION = "STUDENT_ADMINISTRATION",
    MODULE_REGISTRATION = "MODULE_REGISTRATION",
    CANCEL_MODULE_REGISTRATION = "CANCEL_MODULE_REGISTRATION",
    REQUEST_MODULE_REGISTRATION = "REQUEST_MODULE_REGISTRATION",
    CHANGE_MODULE_REGISTRATION = "CHANGE_MODULE_REGISTRATION",
}

export interface ModuleExecutionDto {
    id: number;
    moduleId: number;
    categoryId: number;
    code: string | undefined;
    partialCode: string | undefined;
    semesterId: number;
    semester: string | undefined;
    isActive: boolean;
    hasRegistrations: boolean;
    maxParticipants: number | undefined;
    registrationIsBlocked: boolean;
    locationId: number;
    location: string | undefined;
}

export interface ModuleStructureDto {
    categories: ModuleCategoryDto[] | undefined;
    modules: ModuleDto[] | undefined;
    locations: LocationDto[] | undefined;
}

export interface ModuleCategoryDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    isActive: boolean;
}

export interface ModuleDto {
    id: number;
    categoryId: number;
    code: string | undefined;
    partialCode: string | undefined;
    isActive: boolean;
    hasRelatedData: boolean;
    name: string | undefined;
    recommendedMaxParticipants: number;
}

export interface LocationDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
    hasExecutions: boolean;
}

export interface SemesterSelectionFilter {
    currentAcademicYearId: number;
    defaultSemesterId: number;
    defaultPhaseId: number;
    academicYears: AcademicYearDto[] | undefined;
    semesters: SemesterInfoDto[] | undefined;
}

export interface AcademicYearDto {
    startYear: number;
    name: string | undefined;
    id: number;
    hasSemesters: boolean;
}

export interface SemesterDto {
    id: number;
    academicYearId: number;
    name: string | undefined;
    nameLong: string | undefined;
    start: string;
    end: string | undefined;
    earliestRegistrationDate: string | undefined;
    hasRelatedData: boolean;
}

export interface SemesterInfoDto extends SemesterDto {
    currentPhaseId: number | undefined;
    registrationOpen: boolean;
    phases: PhaseDto[] | undefined;
    isPast: boolean;
}

export interface PhaseDto {
    id: number;
    academicYearId: number;
    semesterId: number;
    name: string | undefined;
    keyDate: string;
    openingDate: string | undefined;
    dateClosed: string | undefined;
    reservePercentage: number;
    isOpen: boolean;
    semester: string | undefined;
    hasRelatedData: boolean;
    isActive: boolean;
    phaseType: PhaseType;
}

export enum PhaseType {
    STANDARD = "STANDARD",
    EXAM_REGISTRATION = "EXAM_REGISTRATION",
}

export interface SwaggerResourceDto {
    name: string | undefined;
    location: string | undefined;
}

export interface AdvisorDto {
    id: string | undefined;
    firstName: string | undefined;
    familyName: string | undefined;
    advisorOf: AdvisorOfDto[] | undefined;
    emails: EmailDto[] | undefined;
    isActive: boolean;
    uas: UasDto[] | undefined;
}

export interface AdvisorOfDto {
    advisorId: string | undefined;
    studentId: string | undefined;
    semesterRegistrationId: number;
    semesterId: number;
    uasId: number;
    uasCode: string | undefined;
    semester: string | undefined;
    studentName: string | undefined;
    isActive: boolean;
}

export interface PersonSearchDto {
    uasIds: number[] | undefined;
    semesterIds: number[] | undefined;
    searchString: string | undefined;
}

export interface UasDomainDto {
    id: number;
    name: string | undefined;
    preferredForStudents: boolean;
    isActive: boolean;
    blockedEmails: string[] | undefined;
    uasIds: number[] | undefined;
}

export interface ExamRegistrationDto {
    examRegistrationId: number;
    moduleRegistrationId: number;
    studentId: string | undefined;
    studentFirstName: string | undefined;
    studentFamilyName: string | undefined;
    studentUASEmail: string | undefined;
    studentPrivateEmail: string | undefined;
    matriculationNumber: string | undefined;
    module: string | undefined;
    moduleCode: string | undefined;
    semester: string | undefined;
    moduleId: number;
    isRegular: boolean;
    state: ExamRegistrationState;
    uasId: number;
    uasCode: string | undefined;
    hasExamRegistration: boolean;
    hasComment: boolean;
    comments: string | undefined;
    hasPreviousAttemptWarning: boolean;
    displayState: string | undefined;
    openingDate: string | undefined;
    registrationDate: string | undefined;
}

export enum ExamRegistrationState {
    NOT_REGISTERED = "NOT_REGISTERED",
    CONFIRMED = "CONFIRMED",
    WITHDRAWN = "WITHDRAWN",
    ABSENT_EXCUSED = "ABSENT_EXCUSED",
}

export interface PreviousExamAttemptDto {
    academicYear: string | undefined;
    semester: string | undefined;
    isRegular: boolean;
    state: ExamRegistrationState;
}

export interface SetOpeningDateRequest {
    openingDate: string | undefined;
}

export interface FilterPresetDto {
    filter: RegistrationFilterSelectionDto | undefined;
    id: number;
    name: string | undefined;
    forRoles: RoleType[] | undefined;
    template: string | undefined;
    templateId: number | undefined;
    fileName: string | undefined;
    isOwner: boolean;
    owner: string | undefined;
}

export interface RegistrationFilterSelectionDto {
    columnNames: string[] | undefined;
    uasIds: number[] | undefined;
    semesterIds: number[] | undefined;
    phaseId: number;
    student: SelectionOfString | undefined;
    moduleId: number;
    moduleCategoryId: number;
    moduleExecutionCode: string | undefined;
    labelIds: number[] | undefined;
    profileIds: number[] | undefined;
    advisor: SelectionOfString | undefined;
    locationIds: number[] | undefined;
    fileImport: SelectionOfLong | undefined;
    states: RegistrationState[] | undefined;
    stateAt: string | undefined;
    newerThen: string | undefined;
    hideRegistrations: boolean;
    hideDeRegistrations: boolean;
    presetId: number | undefined;
    hasCompensationForDisadvantages: boolean;
    hasInternalComment: boolean;
    hasComment: boolean;
    hasNoUasEmail: boolean;
    hasManualChanges: boolean;
    studentTypes: StudentType[] | undefined;
}

export interface SelectionOfString {
    id: string | undefined;
    display: string | undefined;
}

export interface SelectionOfLong {
    id: number;
    display: string | undefined;
}

export interface PriorityDto {
    id: number;
    name: string | undefined;
    colorCode: string | undefined;
    isActive: boolean;
    description: string | undefined;
    weighting: number;
    canBeDeleted: boolean;
}

export interface ProfileDto {
    id: number;
    code: string | undefined;
    isActive: boolean;
    inSemesters: number[] | undefined;
}

export interface PriorityAssignmentDto {
    id: string | undefined;
    profileId: number;
    priorityId: number;
    moduleCode: string | undefined;
    moduleExecution: ModuleExecutionDto | undefined;
    priority: PriorityDto | undefined;
}

export interface CopyAcademicYearOptionsDto {
    startYear: number;
    name: string | undefined;
    copyFromId: number;
    copyPriorities: boolean;
    copyModuleExecutions: boolean;
    copyLabels: boolean;
}

export interface CopySemesterOptionsDto {
    toAcademicYearId: number;
    copyFromId: number;
    copyPriorities: boolean;
    copyModuleExecutions: boolean;
    copyLabels: boolean;
    name: string | undefined;
}

export interface RegistrationValidationDto {
    fileImport: FileImportDto | undefined;
    fileIsReadable: boolean;
    fileResultMessage: ValidationMessage | undefined;
    detailedMessages: ValidationMessage[] | undefined;
    registrationImport: RegistrationImport | undefined;
    resultedSheet: RegistrationSheet | undefined;
    columnInformation: ExcelColumn[] | undefined;
    canSubmit: boolean;
    count: ValidationCountDto | undefined;
    phaseId: number | undefined;
}

export interface FileImportDto {
    id: number;
    semester: string | undefined;
    semesterId: number;
    phase: string | undefined;
    phaseId: number | undefined;
    uas: string | undefined;
    uasId: number;
    uploadedById: string | undefined;
    uploadedByName: string | undefined;
    fileName: string | undefined;
    importedDate: string | undefined;
    uploadedDate: string;
    importedById: string | undefined;
    importedByName: string | undefined;
    importState: ImportState;
    comments: CommentDto[] | undefined;
}

export enum ImportState {
    UPLOADED = "UPLOADED",
    REQUESTED = "REQUESTED",
    IMPORTED = "IMPORTED",
    REJECTED = "REJECTED",
    WITHDRAWN = "WITHDRAWN",
    DELETED = "DELETED",
}

export interface ValidationMessage {
    level: ValidationLevel;
    message: string | undefined;
    correctionHint: string | undefined;
    cells: ExcelCell[] | undefined;
    noRights: boolean;
    comparison: ItemComparison | undefined;
    code: RuleCode;
    codeValue: number;
}

export enum ValidationLevel {
    Success = "Success",
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export interface ExcelColumn {
    columnName: string | undefined;
    columnNumber: number;
    required: boolean;
    fullName: string | undefined;
    propertyName: string | undefined;
}

export interface ExcelCell extends ExcelColumn {
    row: number;
}

export interface ItemComparison {
    item: string | undefined;
    knownItem: string | undefined;
}

export enum RuleCode {
    None = "None",
    NoReadableContent = "NoReadableContent",
    InvalidFileFormat = "InvalidFileFormat",
    NoRegistrationFound = "NoRegistrationFound",
    FileLocked = "FileLocked",
    ErrorWhileParsing = "ErrorWhileParsing",
    UnknownParsingError = "UnknownParsingError",
    FileReadable = "FileReadable",
    NoValidSemesterSelected = "NoValidSemesterSelected",
    SemesterNotFoundInDatabase = "SemesterNotFoundInDatabase",
    NoUasFound = "NoUasFound",
    OnlyDeclaredUasAllowed = "OnlyDeclaredUasAllowed",
    OnlyOneUasAllowed = "OnlyOneUasAllowed",
    UasNotFound = "UasNotFound",
    NoRightForUas = "NoRightForUas",
    EmptyRowIgnored = "EmptyRowIgnored",
    EmptyRowsIgnored = "EmptyRowsIgnored",
    NoRegistrationDate = "NoRegistrationDate",
    RegistrationDateInFuture = "RegistrationDateInFuture",
    RegistrationDateToEarly = "RegistrationDateToEarly",
    MatriculationNumberAutoformatted = "MatriculationNumberAutoformatted",
    MatriculationNumberNotConvertable = "MatriculationNumberNotConvertable",
    MatriculationNumberAutofilled = "MatriculationNumberAutofilled",
    MatriculationNumberIgnored = "MatriculationNumberIgnored",
    StudentEmailAutomaticallyCorrected = "StudentEmailAutomaticallyCorrected",
    AutoFilledPrivateEmail = "AutoFilledPrivateEmail",
    AutoFilledUASEmail = "AutoFilledUASEmail",
    BirthdateAutofilled = "BirthdateAutofilled",
    AdvisorFamilyNameAutomaticallyCorrected = "AdvisorFamilyNameAutomaticallyCorrected",
    AdvisorFirstNameAutomaticallyCorrected = "AdvisorFirstNameAutomaticallyCorrected",
    AdvisorEmailAutomaticallyCorrected = "AdvisorEmailAutomaticallyCorrected",
    AdvisorEmailAutofilled = "AdvisorEmailAutofilled",
    AdvisorNameAutofilled = "AdvisorNameAutofilled",
    EmailIsNotValid = "EmailIsNotValid",
    EmailNotAllowed = "EmailNotAllowed",
    EmailShouldBePrivate = "EmailShouldBePrivate",
    EmailNotAllowedByUas = "EmailNotAllowedByUas",
    EmailDomainNotPrefered = "EmailDomainNotPrefered",
    MissingModuleExecutionCode = "MissingModuleExecutionCode",
    InvalidModuleCode = "InvalidModuleCode",
    InvalidModuleCodeForSemester = "InvalidModuleCodeForSemester",
    InvalidModuleExecutionCode = "InvalidModuleExecutionCode",
    ModuleExecutionNotCarriedOutInSemester = "ModuleExecutionNotCarriedOutInSemester",
    ModuleExecutionNotCarriedOutInSemesterWithSeveralOptions = "ModuleExecutionNotCarriedOutInSemesterWithSeveralOptions",
    InvalidModuleExecutionCodeWithOneOption = "InvalidModuleExecutionCodeWithOneOption",
    InvalidModuleExecutionCodeWithSeveralOptions = "InvalidModuleExecutionCodeWithSeveralOptions",
    FirstNameMissing = "FirstNameMissing",
    FamilyNameMissing = "FamilyNameMissing",
    NoProfile = "NoProfile",
    InvalidProfile = "InvalidProfile",
    AuditorNeedsAuditorProfile = "AuditorNeedsAuditorProfile",
    StudentHasInvalidProfile = "StudentHasInvalidProfile",
    RegistrationOrDeregistration = "RegistrationOrDeregistration",
    InconsistentAdvisor = "InconsistentAdvisor",
    InconsistentFiledsWithSameBirthday = "InconsistentFiledsWithSameBirthday",
    InconsistentFieldsWithSamePrivateEmail = "InconsistentFieldsWithSamePrivateEmail",
    InconsistentFieldsWithSameUASEmail = "InconsistentFieldsWithSameUASEmail",
    InconsistentFieldsWithSameMatrNr = "InconsistentFieldsWithSameMatrNr",
    InconsistentMultipleMatriculationNumbers = "InconsistentMultipleMatriculationNumbers",
    StudentsWithSameNameButNoAdditionalInformation = "StudentsWithSameNameButNoAdditionalInformation",
    ErrorDuringSheetValidation = "ErrorDuringSheetValidation",
    ErrorWhileNormalizing = "ErrorWhileNormalizing",
    DuplicateRegistration = "DuplicateRegistration",
    IgnoredRegistrations = "IgnoredRegistrations",
    DeleteRegistrations = "DeleteRegistrations",
    DuplicateModuleRegistrationEntryWithSameDate = "DuplicateModuleRegistrationEntryWithSameDate",
    IgnoredRegistrationForModule = "IgnoredRegistrationForModule",
    IgnoredMultipleRegistrations = "IgnoredMultipleRegistrations",
    IgnoredMultipleRegistrationsForModule = "IgnoredMultipleRegistrationsForModule",
    AdvisorHasNoName = "AdvisorHasNoName",
    LoginRequired = "LoginRequired",
    RoleRequired = "RoleRequired",
    AdvisorEmailMapped = "AdvisorEmailMapped",
    NewAdvisorEmail = "NewAdvisorEmail",
    NewAdvisor = "NewAdvisor",
    AdvisorNameLooksVeryDifferent = "AdvisorNameLooksVeryDifferent",
    AdvisorEmailBelongsToDifferentPerson = "AdvisorEmailBelongsToDifferentPerson",
    StudentsEmailBelongsToDifferentPerson = "StudentsEmailBelongsToDifferentPerson",
    DifferentExistingEmailForAdvisor = "DifferentExistingEmailForAdvisor",
    DifferentExistingEmail = "DifferentExistingEmail",
    NormalizedUas = "NormalizedUas",
    NormalizedProfile = "NormalizedProfile",
    StudentCantBeMatched = "StudentCantBeMatched",
    StudentHasOnePossibleMatch = "StudentHasOnePossibleMatch",
    StudentNameLooksVeryDifferent = "StudentNameLooksVeryDifferent",
    AddingStudentWithoutKey = "AddingStudentWithoutKey",
    StudentInDbWithoutKey = "StudentInDbWithoutKey",
    StudentWithOnlyBirthDate = "StudentWithOnlyBirthDate",
    AdvisorCantBeMatched = "AdvisorCantBeMatched",
    AdvisorHasOnePossibleMatch = "AdvisorHasOnePossibleMatch",
    AdvisorEmailCantBeAssignedBecauseItBelongsToADifferentPerson = "AdvisorEmailCantBeAssignedBecauseItBelongsToADifferentPerson",
    MappedToStudent = "MappedToStudent",
    StudentsWithTheSameName = "StudentsWithTheSameName",
    SimilarStudents = "SimilarStudents",
    EmailsBelongToDifferentStudent = "EmailsBelongToDifferentStudent",
    MappedToStudentEmail = "MappedToStudentEmail",
    NewEmailForStudent = "NewEmailForStudent",
    NewStudent = "NewStudent",
    MappedStudentByMatriculationNumber = "MappedStudentByMatriculationNumber",
    FamilyNameKeptFromDatabase = "FamilyNameKeptFromDatabase",
    FamilyNameAssigned = "FamilyNameAssigned",
    FamilyNameChangeConfirmed = "FamilyNameChangeConfirmed",
    FamilyNameWhitespaceCleared = "FamilyNameWhitespaceCleared",
    FamilyNameChangeToConfirm = "FamilyNameChangeToConfirm",
    FirstNameKeptFromDatabase = "FirstNameKeptFromDatabase",
    FirstNameAssigned = "FirstNameAssigned",
    FirstNameChangeConfirmed = "FirstNameChangeConfirmed",
    FirstNameWhitespaceCleared = "FirstNameWhitespaceCleared",
    FirstNameChangeToConfirm = "FirstNameChangeToConfirm",
    PrivateEmailKeptFromDatabase = "PrivateEmailKeptFromDatabase",
    PrivateEmailAssigned = "PrivateEmailAssigned",
    PrivateEmailChangeConfirmed = "PrivateEmailChangeConfirmed",
    PrivateEmailWhitespaceCleared = "PrivateEmailWhitespaceCleared",
    PrivateEmailChangeToConfirm = "PrivateEmailChangeToConfirm",
    UasEmailKeptFromDatabase = "UasEmailKeptFromDatabase",
    UasEmailAssigned = "UasEmailAssigned",
    UasEmailChangeConfirmed = "UasEmailChangeConfirmed",
    UasEmailWhitespaceCleared = "UasEmailWhitespaceCleared",
    UasEmailChangeToConfirm = "UasEmailChangeToConfirm",
    MatriculationNumberKeptFromDatabase = "MatriculationNumberKeptFromDatabase",
    MatriculationNumberAssigned = "MatriculationNumberAssigned",
    MatriculationNumberChangeConfirmed = "MatriculationNumberChangeConfirmed",
    MatriculationNumberWhitespaceCleared = "MatriculationNumberWhitespaceCleared",
    MatriculationNumberChangeToConfirm = "MatriculationNumberChangeToConfirm",
    PreviousDegreeKeptFromDatabase = "PreviousDegreeKeptFromDatabase",
    PreviousDegreeAssigned = "PreviousDegreeAssigned",
    PreviousDegreeChangeConfirmed = "PreviousDegreeChangeConfirmed",
    PreviousDegreeWhitespaceCleared = "PreviousDegreeWhitespaceCleared",
    PreviousDegreeChangedSilently = "PreviousDegreeChangedSilently",
    BirthDateKeptFromDatabase = "BirthDateKeptFromDatabase",
    BirthDateChangeConfirmed = "BirthDateChangeConfirmed",
    BirthDateChangeToConfirm = "BirthDateChangeToConfirm",
    ModuleRegistrationStateChanged = "ModuleRegistrationStateChanged",
    CancelledCantChangeToRequested = "CancelledCantChangeToRequested",
    AbsentexCantBeChanged = "AbsentexCantBeChanged",
    ChangedToRequested = "ChangedToRequested",
    DeregistrationOnMissingRegistration = "DeregistrationOnMissingRegistration",
    NewModuleRegistration = "NewModuleRegistration",
    AdvisorChange = "AdvisorChange",
    MappedToUas = "MappedToUas",
    MappedToUasWithNewRole = "MappedToUasWithNewRole",
    MappedToUasWithNewSemesterRegistration = "MappedToUasWithNewSemesterRegistration",
    AssignedToFirstProfile = "AssignedToFirstProfile",
    KeptProfile = "KeptProfile",
    KeptProfileFromLastSemester = "KeptProfileFromLastSemester",
    ProfileChangeDuringSemester = "ProfileChangeDuringSemester",
    ProfileChange = "ProfileChange",
    ProfileChangeBecauseOfRename = "ProfileChangeBecauseOfRename",
    UasChangeDuringSemester = "UasChangeDuringSemester",
    UasChanged = "UasChanged",
    NewRegistrationIfAlreadyRegistered = "NewRegistrationIfAlreadyRegistered",
    StudentWantsToApplyAgain = "StudentWantsToApplyAgain",
    ErrorDuringNormalizedValidation = "ErrorDuringNormalizedValidation",
    NoChanges = "NoChanges",
    FileParsedResult = "FileParsedResult",
}

export interface RegistrationImport {
    semesterId: number;
    importDbId: number | undefined;
    uasId: number;
    students: StudentImport[] | undefined;
    advisors: AdvisorImport[] | undefined;
    validationLevel: ValidationLevel;
    nrOfStudentChanges: number;
    nrOfRegistrationChanges: number;
    nrOfAdvisorChanges: number;
    nrOfUserConfirmations: number;
    nrOfUnconfirmedConfirmations: number;
    hasChanges: boolean;
}

export interface StudentImport {
    guid: string | undefined;
    moduleRegistrations: ModuleRegistrationImport[] | undefined;
    birthDate: string | undefined;
    birthDateChange: ValueChangeOfNullableDateTime | undefined;
    dbMapping: DatabaseMappingOfString | undefined;
    matriculationNumber: string | undefined;
    matriculationNumberChange: ValueChangeOfString | undefined;
    firstName: string | undefined;
    firstNameChange: ValueChangeOfString | undefined;
    familyName: string | undefined;
    familyNameChange: ValueChangeOfString | undefined;
    semesterRegistrationId: number | undefined;
    uasMapping: DatabaseMappingOfNullableLong | undefined;
    uasEmail: EmailImport | undefined;
    previousDegree: string | undefined;
    previousDegreeChange: ValueChangeOfString | undefined;
    privateEmail: EmailImport | undefined;
    advisorGuid: string | undefined;
    profileId: number;
    profileMapping: DatabaseMappingOfNullableLong | undefined;
    advisorMapping: DatabaseMappingOfString | undefined;
    isMappedToDb: boolean;
    hasAdvisorChange: boolean;
    nrOfRegistrationChanges: number;
    nrOfChanges: number;
    nrOfUserConfirmations: number;
    nrOfUnconfirmedConfirmations: number;
    validationLevel: ValidationLevel;
    registrationValidationLevel: ValidationLevel;
    isNew: boolean;
}

export interface ModuleRegistrationImport {
    rowNumber: number;
    dateOfRegistration: string;
    moduleExecutionId: number;
    moduleExecutionCode: string | undefined;
    isDeregistration: boolean;
    databaseId: number | undefined;
    validationLevel: ValidationLevel;
    isMappedToDb: boolean;
    registrationStateChange: ValueChangeOfRegistrationState | undefined;
    hasChanges: boolean;
}

export interface ChangeConfirmation {
    conflictMessage: string | undefined;
    confirmationComment: string | undefined;
    confirmedById: string | undefined;
    confirmedByName: string | undefined;
    wasJustConfirmed: boolean;
    confirmedDate: string;
    validationLevel: ValidationLevel;
    isUserConfirmed: boolean;
    needsConfirmation: boolean;
    code: RuleCode;
    codeValue: number;
    sourceEntityType: string | undefined;
    sourcePropertyName: string | undefined;
    targetEntityType: string | undefined;
    targetPropertyName: string | undefined;
    combinationCode: string | undefined;
}

export interface ValueChange extends ChangeConfirmation {
    confirmationType: ValueChangeType;
    solutions: ValueChangeSolution[] | undefined;
}

export interface ValueChangeOfRegistrationState extends ValueChange {
    newValue: RegistrationState;
    oldValue: RegistrationState;
}

export enum ValueChangeType {
    TakeNewValue = "TakeNewValue",
    KeepOldValue = "KeepOldValue",
    Choice = "Choice",
}

export interface ValueChangeSolution {
    type: ValueChangeType;
    message: string | undefined;
}

export interface ValueChangeOfNullableDateTime extends ValueChange {
    newValue: string | undefined;
    oldValue: string | undefined;
}

export interface MappingChangeConfirmationOfString extends ChangeConfirmation {
    executedSolution: ExecutedSolutionOfString | undefined;
    solutions: MappingConfirmationSolution[] | undefined;
    possibilities: MappingPossibilityOfString[] | undefined;
}

export interface DatabaseMappingOfString extends MappingChangeConfirmationOfString {
    identifier: string | undefined;
    databaseId: string | undefined;
    oldIdentifier: string | undefined;
    oldDatabaseId: string | undefined;
    mappingChanged: boolean;
    isMappedToDb: boolean;
    isNew: boolean;
}

export interface ExecutedSolutionOfString {
    type: MappingActionType;
    databaseId: string | undefined;
}

export enum MappingActionType {
    None = "None",
    ConfirmNew = "ConfirmNew",
    SelectPossibility = "SelectPossibility",
    IgnoreValue = "IgnoreValue",
}

export interface MappingConfirmationSolution {
    type: MappingActionType;
    message: string | undefined;
    needsAdminRights: boolean;
}

export interface MappingPossibilityOfString {
    databaseId: string | undefined;
    display: string | undefined;
    distance: number;
}

export interface ValueChangeOfString extends ValueChange {
    newValue: string | undefined;
    oldValue: string | undefined;
}

export interface MappingChangeConfirmationOfNullableLong extends ChangeConfirmation {
    executedSolution: ExecutedSolutionOfNullableLong | undefined;
    solutions: MappingConfirmationSolution[] | undefined;
    possibilities: MappingPossibilityOfNullableLong[] | undefined;
}

export interface DatabaseMappingOfNullableLong extends MappingChangeConfirmationOfNullableLong {
    identifier: string | undefined;
    databaseId: number | undefined;
    oldIdentifier: string | undefined;
    oldDatabaseId: number | undefined;
    mappingChanged: boolean;
    isMappedToDb: boolean;
    isNew: boolean;
}

export interface ExecutedSolutionOfNullableLong {
    type: MappingActionType;
    databaseId: number | undefined;
}

export interface MappingPossibilityOfNullableLong {
    databaseId: number | undefined;
    display: string | undefined;
    distance: number;
}

export interface EmailImport {
    guid: string | undefined;
    name: string | undefined;
    nameChange: ValueChangeOfString | undefined;
    dbMapping: DatabaseMappingOfNullableLong | undefined;
    nrOfChanges: number;
    nrOfUserConfirmations: number;
    nrOfUnconfirmedConfirmations: number;
    isMappedToDb: boolean;
    validationLevel: ValidationLevel;
    isNew: boolean;
}

export interface AdvisorImport {
    guid: string | undefined;
    familyName: string | undefined;
    familyNameChange: ValueChangeOfString | undefined;
    firstName: string | undefined;
    firstNameChange: ValueChangeOfString | undefined;
    uasEmail: EmailImport | undefined;
    dbMapping: DatabaseMappingOfString | undefined;
    validationLevel: ValidationLevel;
    isMappedToDb: boolean;
    isNew: boolean;
    nrOfChanges: number;
    nrOfUserConfirmations: number;
    nrOfUnconfirmedConfirmations: number;
}

export interface RegistrationSheet {
    partOfUAS: string | undefined;
    semester: string | undefined;
    rows: RegistrationRow[] | undefined;
}

export interface RegistrationRow {
    rowNumber: number;
    isEmpty: boolean;
    dateOfRegistration: string | undefined;
    isDeregistration: boolean;
    isRegistration: boolean;
    partOfUAS: string | undefined;
    familyNameOfStudent: string | undefined;
    firstNameOfStudent: string | undefined;
    matriculationNumber: string | undefined;
    birthDate: string | undefined;
    privateEmail: string | undefined;
    studentUASEmail: string | undefined;
    moduleCode: string | undefined;
    profileOrSpecialisation: string | undefined;
    previousDegree: string | undefined;
    advisorFamilyName: string | undefined;
    advisorFirstName: string | undefined;
    advisorUASEmail: string | undefined;
}

export interface ValidationCountDto {
    errors: number;
    warnings: number;
    infos: number;
    studentChanges: number;
    registrationChanges: number;
    userConfirmations: number;
    advisorChanges: number;
    unconfirmedConfirmations: number;
}

export interface StaticRegistrationFilterDto {
    columns: ExcelColumn[] | undefined;
    labels: SelectionOfLong[] | undefined;
    profiles: SelectionOfLong[] | undefined;
    locations: SelectionOfLong[] | undefined;
    states: RegistrationState[] | undefined;
    defaultColumns: ExcelColumn[] | undefined;
}

export interface RuleGroupInfo {
    code: number;
    description: string | undefined;
    validatorInfos: ValidatorInfo[] | undefined;
}

export interface ValidatorInfo {
    name: string | undefined;
    description: string | undefined;
    subGroup: RuleGroup | undefined;
    rules: RuleInfo[] | undefined;
    validatorType: string | undefined;
    mainGroup: RuleGroup | undefined;
    allowsMoreThanOneSubGroup: boolean;
    isNormalizedValidator: boolean;
    isSheetValidator: boolean;
    isDbMapper: boolean;
    isNormalizer: boolean;
}

export interface RuleGroup {
    code: number;
    description: string | undefined;
    isSubGroup: boolean;
}

export interface RuleInfo {
    code: RuleCode;
    codeValue: number;
    description: string | undefined;
    name: string | undefined;
    messageExample: ValidationMessage | undefined;
    confirmationExamples: any[] | undefined;
    exampleErrors: string[] | undefined;
    showsCells: boolean;
    creatorMethods: string[] | undefined;
}

export interface ExcelTemplateDto {
    id: number;
    name: string | undefined;
    fileName: string | undefined;
    isActive: boolean;
    exportType: ExcelExportType;
}

export enum ExcelExportType {
    None = "None",
    Registrations = "Registrations",
    SummarySheet = "SummarySheet",
    ExamRegistrations = "ExamRegistrations",
}

export interface LabelDto {
    id: number;
    name: string | undefined;
    isActive: boolean;
}

export interface CopyModuleStructureDto {
    fromAcademicYearId: number;
    toAcademicYearId: number;
    copyPriorities: boolean;
    copyLabels: boolean;
}

export interface CopyModuleDto {
    fromAcademicYearId: number;
    toAcademicYearId: number;
    copyPriorities: boolean;
    copyLabels: boolean;
    moduleId: number;
}

export interface SemesterRegistrationDto {
    id: number;
    semesterId: number;
    semester: string | undefined;
    semesterStart: string;
    registeredAtId: number;
    registeredAt: string | undefined;
    profile: string | undefined;
    profileId: number;
    advisorName: string | undefined;
    advisorId: string | undefined;
    labelId: number | undefined;
    label: string | undefined;
    isActive: boolean;
    studentId: string | undefined;
    studentFirstName: string | undefined;
    studentFamilyName: string | undefined;
    studentType: StudentType;
    moduleRegistrations: ModuleRegistrationDto[] | undefined;
    examRegistrations: ExamRegistrationDto[] | undefined;
}

export interface StudentPreviewDto {
    id: string | undefined;
    firstName: string | undefined;
    familyName: string | undefined;
    birthDate: string | undefined;
    previousDegree: string | undefined;
    emails: string[] | undefined;
    semesterRegistrations: SemesterRegistrationPreviewDto[] | undefined;
    matriculationNr: string | undefined;
}

export interface SemesterRegistrationPreviewDto {
    semesterId: number;
    semester: string | undefined;
    uas: string | undefined;
    profile: string | undefined;
    uasId: number;
    studentType: StudentType;
}

export interface StudentDto {
    id: string | undefined;
    firstName: string | undefined;
    familyName: string | undefined;
    birthDate: string | undefined;
    previousDegree: string | undefined;
    emails: EmailDto[] | undefined;
    semesterRegistrations: SemesterRegistrationDto[] | undefined;
    matriculationNr: string | undefined;
    hasHiddenInformation: boolean;
}

export interface AutoConfirmProgress {
    moduleExecutionId: number;
    totalModules: number;
    processedModules: number;
    confirmedCount: number;
    requestedCount: number;
    waitingCount: number;
    blockedCount: number;
    updated: boolean;
    isCompleted: boolean;
}

export interface AutoConfirmCompleted {
    success: boolean;
    totalModules: number;
    autoPrioritizedModules: number;
    manualReviewModules: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}